"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2349],{

/***/ 10192:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Caml_exceptions = __webpack_require__(96181);
var JsExn = /* @__PURE__ */ Caml_exceptions.create("GoogleApis-SmartcutsMacros.JsExn");
var isGapiUndefined = function() {
    return typeof gapi == "undefined";
};
var waitForClient = function awaitClient(callback) {
    if (!gapi.client) {
        window.gapi_onload = function() {
            return callback();
        };
    } else {
        callback();
    }
};
function waitForClientPromise(param) {
    return new Promise(function(resolve, param) {
        return waitForClient(resolve);
    });
}
function httpResponseResultError_encode(v) {
    return Js_dict.fromArray([
        [
            "code",
            Decco.intToJson(v.code)
        ],
        [
            "message",
            Decco.stringToJson(v.message)
        ],
        [
            "status",
            Decco.stringToJson(v.status)
        ]
    ]);
}
function httpResponseResultError_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var code = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "code"), null));
    if (code.TAG === /* Ok */ 0) {
        var message = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "message"), null));
        if (message.TAG === /* Ok */ 0) {
            var status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
            if (status.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        code: code._0,
                        message: message._0,
                        status: status._0
                    }
                };
            }
            var e = status._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".status" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = message._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".message" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = code._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".code" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function httpResponseResult_encode(v) {
    return Js_dict.fromArray([
        [
            "error",
            httpResponseResultError_encode(v.error)
        ]
    ]);
}
function httpResponseResult_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var error = httpResponseResultError_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "error"), null));
    if (error.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: {
                error: error._0
            }
        };
    }
    var e = error._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".error" + e.path,
            message: e.message,
            value: e.value
        }
    };
}
function httpResponse_encode(v) {
    return Js_dict.fromArray([
        [
            "body",
            Decco.stringToJson(v.body)
        ],
        [
            "headers",
            Decco.dictToJson(Decco.stringToJson, v.headers)
        ],
        [
            "result",
            httpResponseResult_encode(v.result)
        ]
    ]);
}
function httpResponse_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var body = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "body"), null));
    if (body.TAG === /* Ok */ 0) {
        var headers = Decco.dictFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "headers"), null));
        if (headers.TAG === /* Ok */ 0) {
            var result = httpResponseResult_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "result"), null));
            if (result.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        body: body._0,
                        headers: headers._0,
                        result: result._0
                    }
                };
            }
            var e = result._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".result" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = headers._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".headers" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = body._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".body" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var Auth;
var Sheets;
exports.Auth = Auth;
exports.Sheets = Sheets;
exports.JsExn = JsExn;
exports.isGapiUndefined = isGapiUndefined;
exports.waitForClient = waitForClient;
exports.waitForClientPromise = waitForClientPromise;
exports.httpResponseResultError_encode = httpResponseResultError_encode;
exports.httpResponseResultError_decode = httpResponseResultError_decode;
exports.httpResponseResult_encode = httpResponseResult_encode;
exports.httpResponseResult_decode = httpResponseResult_decode;
exports.httpResponse_encode = httpResponse_encode;
exports.httpResponse_decode = httpResponse_decode; /* No side effect */ 


/***/ }),

/***/ 59370:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var $$String = __webpack_require__(65760);
var Js_json = __webpack_require__(85688);
function dataURIToBinary(dataURI) {
    var base64Marker = ";base64,";
    var base64Index = dataURI.indexOf(base64Marker) + base64Marker.length | 0;
    var base64 = dataURI.slice(base64Index);
    var raw = atob(base64);
    var rawLength = raw.length;
    var array = new Uint8ClampedArray(new ArrayBuffer(rawLength));
    $$String.iteri(function(i, _char) {
        array[i] = raw.charCodeAt(i) | 0;
    }, raw);
    return array;
}
function t_encode(v) {
    return URL.createObjectURL(v);
}
function t_decode(encoded) {
    var s = Js_json.decodeString(encoded);
    if (s !== undefined) {
        return {
            TAG: /* Ok */ 0,
            _0: new Blob([
                dataURIToBinary(s)
            ], {
                type: "image/jpeg"
            })
        };
    } else {
        return Decco.error(undefined, "Couldn't decode Blob", encoded);
    }
}
exports.dataURIToBinary = dataURIToBinary;
exports.t_encode = t_encode;
exports.t_decode = t_decode; /* No side effect */ 


/***/ }),

/***/ 54278:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Caml_exceptions = __webpack_require__(96181);
var Promise_canceled = /* @__PURE__ */ Caml_exceptions.create("Exceptions-SmartcutsMacros.Promise.Promise_canceled");
var $$Promise = {
    Promise_canceled: Promise_canceled
};
var Invalid_url = /* @__PURE__ */ Caml_exceptions.create("Exceptions-SmartcutsMacros.URL.Invalid_url");
var $$URL = {
    Invalid_url: Invalid_url
};
var Internal_server_error = /* @__PURE__ */ Caml_exceptions.create("Exceptions-SmartcutsMacros.FaunaGraphql.Internal_server_error");
var Service_not_available = /* @__PURE__ */ Caml_exceptions.create("Exceptions-SmartcutsMacros.FaunaGraphql.Service_not_available");
var FaunaGraphql = {
    Internal_server_error: Internal_server_error,
    Service_not_available: Service_not_available
};
exports.$$Promise = $$Promise;
exports.$$URL = $$URL;
exports.FaunaGraphql = FaunaGraphql; /* No side effect */ 


/***/ }),

/***/ 68387:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Caml = __webpack_require__(16253);
var Uuid = __webpack_require__(97466);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Js_math = __webpack_require__(84763);
var Belt_Array = __webpack_require__(2971);
var Caml_array = __webpack_require__(11748);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Rect$SmartcutsMacros = __webpack_require__(13099);
var DOM__Blob$SmartcutsMacros = __webpack_require__(59370);
function t_encode(v) {
    if (v) {
        return [
            "PNG"
        ];
    } else {
        return [
            "JPEG"
        ];
    }
}
function t_decode(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "JPEG":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* JPEG */ 0
                    };
                }
            case "PNG":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PNG */ 1
                    };
                }
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function stringify(format) {
    if (format) {
        return "png";
    } else {
        return "jpeg";
    }
}
function mimeType(v) {
    if (v) {
        return "image/png";
    } else {
        return "image/jpeg";
    }
}
function extension(v) {
    if (v) {
        return "png";
    } else {
        return "jpeg";
    }
}
var Format = {
    t_encode: t_encode,
    t_decode: t_decode,
    stringify: stringify,
    mimeType: mimeType,
    extension: extension
};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "format",
            t_encode(v.format)
        ],
        [
            "width",
            Decco.intToJson(v.width)
        ],
        [
            "height",
            Decco.intToJson(v.height)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var format = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "format"), null));
    if (format.TAG === /* Ok */ 0) {
        var width = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "width"), null));
        if (width.TAG === /* Ok */ 0) {
            var height = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "height"), null));
            if (height.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        format: format._0,
                        width: width._0,
                        height: height._0
                    }
                };
            }
            var e = height._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".height" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = width._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".width" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = format._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".format" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
function stringify$1(param) {
    return "{ format: " + ((param.format ? "png" : "jpeg") + (", width: " + (String(param.width) + (", height: " + (String(param.height) + " }")))));
}
var Metadata = {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1
};
function t_encode$2(v) {
    if (v.TAG === /* Base64Encoded */ 0) {
        return [
            "Base64Encoded",
            Decco.stringToJson(v._0)
        ];
    } else {
        return [
            "Blob",
            DOM__Blob$SmartcutsMacros.t_encode(v._0)
        ];
    }
}
function t_decode$2(v) {
    var jsonArr = Js_json.classify(v);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "Base64Encoded":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Base64Encoded */ 0,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "Blob":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
                }
                var v0$1 = DOM__Blob$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* Blob */ 1,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function toBlob(format, data) {
    if (data.TAG === /* Base64Encoded */ 0) {
        return new Blob([
            DOM__Blob$SmartcutsMacros.dataURIToBinary(data._0)
        ], {
            type: format ? "image/png" : "image/jpeg"
        });
    } else {
        return data._0;
    }
}
function toImageSrc(data) {
    if (data.TAG === /* Base64Encoded */ 0) {
        return data._0;
    } else {
        return URL.createObjectURL(data._0);
    }
}
var Data = {
    t_encode: t_encode$2,
    t_decode: t_decode$2,
    toBlob: toBlob,
    toImageSrc: toImageSrc
};
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "format",
            t_encode(v.format)
        ],
        [
            "data",
            t_encode$2(v.data)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var format = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "format"), null));
    if (format.TAG === /* Ok */ 0) {
        var data = t_decode$2(Belt_Option.getWithDefault(Js_dict.get(dict$1, "data"), null));
        if (data.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    format: format._0,
                    data: data._0
                }
            };
        }
        var e = data._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".data" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = format._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".format" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function t_encode$4(v) {
    return Js_dict.fromArray([
        [
            "width",
            Decco.floatToJson(v.width)
        ],
        [
            "height",
            Decco.floatToJson(v.height)
        ]
    ]);
}
function t_decode$4(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var width = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "width"), null));
    if (width.TAG === /* Ok */ 0) {
        var height = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "height"), null));
        if (height.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    width: width._0,
                    height: height._0
                }
            };
        }
        var e = height._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".height" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = width._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".width" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function stringify$2(s) {
    return JSON.stringify(s);
}
function calcResizeDimensions(maxWidth, maxHeight, param) {
    var height = param.height;
    var width = param.width;
    var match;
    if (width > maxWidth) {
        var ratio = maxWidth / width;
        match = [
            maxWidth,
            height * ratio,
            ratio
        ];
    } else {
        match = [
            width,
            height,
            1.0
        ];
    }
    var ratio1 = match[2];
    var height2 = match[1];
    var width2 = match[0];
    if (height2 <= maxHeight) {
        return [
            {
                width: width2,
                height: height2
            },
            ratio1
        ];
    }
    var ratio2 = maxHeight / height2;
    return [
        {
            width: width2 * ratio2,
            height: maxHeight
        },
        ratio1 * ratio2
    ];
}
var Size = {
    t_encode: t_encode$4,
    t_decode: t_decode$4,
    stringify: stringify$2,
    calcResizeDimensions: calcResizeDimensions
};
function make(mockHtmlImageOnloadOpt, maybeWidth, maybeHeight, src) {
    var mockHtmlImageOnload = mockHtmlImageOnloadOpt !== undefined ? mockHtmlImageOnloadOpt : false;
    return new Promise(function(resolve, param) {
        var img = maybeWidth !== undefined ? maybeHeight !== undefined ? new Image(maybeWidth, maybeHeight) : new Image() : new Image();
        if (mockHtmlImageOnload) {
            resolve(img);
        } else {
            img.onload = function(param) {
                return resolve(img);
            };
        }
        img.src = src;
    });
}
function make$1(width, height, param) {
    var canvasEl = document.createElement("canvas");
    if (width !== undefined) {
        canvasEl.setAttribute("width", width.toString());
    }
    if (height !== undefined) {
        canvasEl.setAttribute("height", height.toString());
    }
    return canvasEl;
}
function scale(canvas, scaleFactor) {
    var f = canvas.width * scaleFactor;
    var width = Js_math.floor(f);
    var f$1 = canvas.height * scaleFactor;
    var height = Js_math.floor(f$1);
    var newCanvas = make$1(width, height, undefined);
    var context = newCanvas.getContext("2d");
    context.drawImage(canvas, 0, 0, width, height);
    return newCanvas;
}
function resizeTo(canvas, width, height) {
    var newCanvas = make$1(width, height, undefined);
    var context = newCanvas.getContext("2d");
    context.drawImage(canvas, 0, 0, width, height);
    return newCanvas;
}
function toBlob$1(mimeType1, quality, canvas) {
    return new Promise(function(resolve, param) {
        canvas.toBlob(function(blob) {
            return resolve(blob);
        }, mimeType1, quality);
    });
}
function toBase64Image(format, canvasEl) {
    return Promise.resolve({
        format: format,
        data: {
            TAG: /* Base64Encoded */ 0,
            _0: canvasEl.toDataURL(format ? "image/png" : "image/jpeg", 1.0)
        }
    });
}
function toBlobImage(format, canvasEl) {
    return toBlob$1(format ? "image/png" : "image/jpeg", 0.7, canvasEl).then(function(blob) {
        return Promise.resolve({
            format: format,
            data: {
                TAG: /* Blob */ 1,
                _0: blob
            }
        });
    });
}
function fillRectWithHexColor(rect, hexColor, canvas) {
    var context = canvas.getContext("2d");
    context.fillStyle = "#" + hexColor;
    context.fillRect(rect.x, rect.y, rect.width, rect.height);
    return canvas;
}
function getSize(data) {
    if (data.TAG === /* Base64Encoded */ 0) {
        return make(undefined, undefined, undefined, data._0).then(function(img) {
            return Promise.resolve({
                width: img.width,
                height: img.height
            });
        });
    } else {
        return make(undefined, undefined, undefined, URL.createObjectURL(data._0)).then(function(img) {
            return Promise.resolve({
                width: img.width,
                height: img.height
            });
        });
    }
}
function minify(param) {
    return {
        format: param.format,
        data: {
            TAG: /* Base64Encoded */ 0,
            _0: ""
        }
    };
}
function makeHtmlImage($staropt$star, param) {
    var data = param.data;
    var mockHtmlImageOnload = $staropt$star !== undefined ? $staropt$star : false;
    if (data.TAG === /* Base64Encoded */ 0) {
        return make(mockHtmlImageOnload, undefined, undefined, data._0);
    } else {
        return make(mockHtmlImageOnload, undefined, undefined, URL.createObjectURL(data._0));
    }
}
function resizeToCanvas(maxWidth, maxHeight, mockHtmlImageOnloadOpt, image) {
    var mockHtmlImageOnload = mockHtmlImageOnloadOpt !== undefined ? mockHtmlImageOnloadOpt : false;
    return makeHtmlImage(mockHtmlImageOnload, image).then(function(htmlImage) {
        var origSize_width = htmlImage.width;
        var origSize_height = htmlImage.height;
        var origSize = {
            width: origSize_width,
            height: origSize_height
        };
        var match = calcResizeDimensions(maxWidth, maxHeight, origSize);
        var newSize = match[0];
        var numTimesToScale = Js_math.floor(Math.log(1 / match[1]) / Math.log(1 / 0.65));
        var match$1;
        if (numTimesToScale === 0) {
            match$1 = [
                make$1(Js_math.floor(newSize.width), Js_math.floor(newSize.height), undefined),
                Js_math.floor(newSize.width),
                Js_math.floor(newSize.height)
            ];
        } else {
            var nextWidth = Js_math.floor(origSize_width * 0.65);
            var nextHeight = Js_math.floor(origSize_height * 0.65);
            match$1 = [
                make$1(nextWidth, nextHeight, undefined),
                nextWidth,
                nextHeight
            ];
        }
        var canvas = match$1[0];
        var context = canvas.getContext("2d");
        context.drawImage(htmlImage, 0, 0, match$1[1], match$1[2]);
        return Belt_Array.reduce(Caml_array.make(numTimesToScale, undefined), Promise.resolve(canvas), function(promise, param) {
            return promise.then(function(currCanvas) {
                return Promise.resolve(scale(currCanvas, 0.65));
            });
        }).then(function(lastCanvas) {
            return Promise.resolve(numTimesToScale === 0 ? lastCanvas : resizeTo(lastCanvas, Js_math.floor(newSize.width), Js_math.floor(newSize.height)));
        });
    });
}
function cropToRect(outOfBoundsFillColor, cropToRect$1, imageToCrop) {
    return makeHtmlImage(undefined, imageToCrop).then(function(htmlImage) {
        var imageRect_width = htmlImage.width;
        var imageRect_height = htmlImage.height;
        var imageRect = {
            x: 0.0,
            y: 0.0,
            width: imageRect_width,
            height: imageRect_height
        };
        if (Rect$SmartcutsMacros.doesNotIntersectWith(imageRect, cropToRect$1)) {
            return Promise.resolve(undefined);
        }
        var sourceRect = Rect$SmartcutsMacros.intersect(imageRect, cropToRect$1);
        var destRect = Rect$SmartcutsMacros.shift(-cropToRect$1.x, -cropToRect$1.y, sourceRect);
        var drawingRect_width = Rect$SmartcutsMacros.right(destRect);
        var drawingRect_height = Rect$SmartcutsMacros.bottom(destRect);
        var drawingRect = {
            x: 0.0,
            y: 0.0,
            width: drawingRect_width,
            height: drawingRect_height
        };
        var canvasDimension = Caml.caml_float_max(Js_math.floor(drawingRect_width), Js_math.floor(drawingRect_height));
        var canvas = make$1(canvasDimension, canvasDimension, undefined);
        var canvas$1 = outOfBoundsFillColor !== undefined ? fillRectWithHexColor(drawingRect, outOfBoundsFillColor, canvas) : canvas;
        var context = canvas$1.getContext("2d");
        context.drawImage(htmlImage, sourceRect.x, sourceRect.y, sourceRect.width, sourceRect.height, destRect.x, destRect.y, destRect.width, destRect.height);
        return Promise.resolve(Caml_option.some(canvas$1));
    });
}
function cropToContainingCircle(paddingOpt, outOfBoundsFillColorOpt, boundingRect, windowSizeWhenBoundingRectTaken, image1) {
    var padding = paddingOpt !== undefined ? paddingOpt : 50;
    var outOfBoundsFillColor = outOfBoundsFillColorOpt !== undefined ? outOfBoundsFillColorOpt : "f0f2f5";
    return makeHtmlImage(undefined, image1).then(function(htmlImage) {
        var targetWindowSize_width = htmlImage.width;
        var targetWindowSize_height = htmlImage.height;
        var scaleHeight = targetWindowSize_height / windowSizeWhenBoundingRectTaken.height;
        var scaleWidth = targetWindowSize_width / windowSizeWhenBoundingRectTaken.width;
        if (scaleHeight !== scaleWidth) {
            console.warn("window height and width not scaled equally");
        }
        var rect = Rect$SmartcutsMacros.ofContainingCircle(Rect$SmartcutsMacros.withPadding(padding, Rect$SmartcutsMacros.scale(scaleHeight, boundingRect)));
        return cropToRect(outOfBoundsFillColor, rect, image1).then(function(maybeCanvas) {
            if (maybeCanvas !== undefined) {
                return toBase64Image(image1.format, Caml_option.valFromOption(maybeCanvas)).then(function(image) {
                    return Promise.resolve(image);
                });
            } else {
                return Promise.resolve(undefined);
            }
        });
    });
}
var id_encode = Decco.stringToJson;
var id_decode = Decco.stringFromJson;
function generateId(param) {
    return Uuid.v1();
}
function makeIdFromString(id) {
    return id;
}
function idAsString(id) {
    return id;
}
function t__encode(v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.stringToJson(v.id)
        ],
        [
            "image",
            t_encode$3(v.image)
        ]
    ]);
}
function t__decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var image = t_decode$3(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
        if (image.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    id: id._0,
                    image: image._0
                }
            };
        }
        var e = image._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".image" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
function minify$1(param) {
    return {
        id: param.id,
        image: minify(param.image)
    };
}
var ImageWithId = {
    t__encode: t__encode,
    t__decode: t__decode,
    minify: minify$1
};
var $$Blob$1;
function HtmlImage_create(prim) {
    return new Image();
}
function HtmlImage_createWithDimension(prim0, prim1) {
    return new Image(prim0, prim1);
}
function HtmlImage_set_src(prim0, prim1) {
    prim0.src = prim1;
}
function HtmlImage_set_onload(prim0, prim1) {
    prim0.onload = prim1;
}
function HtmlImage_width(prim) {
    return prim.width;
}
function HtmlImage_height(prim) {
    return prim.height;
}
var HtmlImage = {
    create: HtmlImage_create,
    createWithDimension: HtmlImage_createWithDimension,
    set_src: HtmlImage_set_src,
    set_onload: HtmlImage_set_onload,
    width: HtmlImage_width,
    height: HtmlImage_height,
    make: make
};
function Canvas_set_imageSmoothingQuality(prim0, prim1) {
    prim0.imageSmoothingQuality = prim1;
}
function Canvas_set_fillStyle(prim0, prim1) {
    prim0.fillStyle = prim1;
}
function Canvas_drawImageToCanvasContext(prim0, prim1, prim2, prim3, prim4, prim5) {
    prim0.drawImage(prim1, prim2, prim3, prim4, prim5);
}
function Canvas_drawImageToCanvasContextOriginalSize(prim0, prim1, prim2, prim3) {
    prim0.drawImage(prim1, prim2, prim3);
}
function Canvas_drawImageToCanvasContextSourceDestination(prim0, prim1, prim2, prim3, prim4, prim5, prim6, prim7, prim8, prim9) {
    prim0.drawImage(prim1, prim2, prim3, prim4, prim5, prim6, prim7, prim8, prim9);
}
function Canvas_drawCanvasToCanvasContext(prim0, prim1, prim2, prim3, prim4, prim5) {
    prim0.drawImage(prim1, prim2, prim3, prim4, prim5);
}
function Canvas_toDataURL(prim0, prim1, prim2) {
    return prim0.toDataURL(prim1, prim2);
}
function Canvas_external_toBlob(prim0, prim1, prim2, prim3) {
    prim0.toBlob(prim1, prim2, prim3);
}
function Canvas_fillRectToCanvasContext(prim0, prim1, prim2, prim3, prim4) {
    prim0.fillRect(prim1, prim2, prim3, prim4);
}
var Canvas = {
    make: make$1,
    set_imageSmoothingQuality: Canvas_set_imageSmoothingQuality,
    set_fillStyle: Canvas_set_fillStyle,
    drawImageToCanvasContext: Canvas_drawImageToCanvasContext,
    drawImageToCanvasContextOriginalSize: Canvas_drawImageToCanvasContextOriginalSize,
    drawImageToCanvasContextSourceDestination: Canvas_drawImageToCanvasContextSourceDestination,
    drawCanvasToCanvasContext: Canvas_drawCanvasToCanvasContext,
    scale: scale,
    resizeTo: resizeTo,
    toDataURL: Canvas_toDataURL,
    external_toBlob: Canvas_external_toBlob,
    toBlob: toBlob$1,
    toBase64Image: toBase64Image,
    toBlobImage: toBlobImage,
    fillRectToCanvasContext: Canvas_fillRectToCanvasContext,
    fillRectWithHexColor: fillRectWithHexColor
};
exports.$$Blob = $$Blob$1;
exports.Format = Format;
exports.Metadata = Metadata;
exports.Data = Data;
exports.t_encode = t_encode$3;
exports.t_decode = t_decode$3;
exports.Size = Size;
exports.HtmlImage = HtmlImage;
exports.Canvas = Canvas;
exports.getSize = getSize;
exports.minify = minify;
exports.makeHtmlImage = makeHtmlImage;
exports.resizeToCanvas = resizeToCanvas;
exports.cropToRect = cropToRect;
exports.cropToContainingCircle = cropToContainingCircle;
exports.id_encode = id_encode;
exports.id_decode = id_decode;
exports.generateId = generateId;
exports.makeIdFromString = makeIdFromString;
exports.idAsString = idAsString;
exports.ImageWithId = ImageWithId; /* uuid Not a pure module */ 


/***/ }),

/***/ 13099:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Array = __webpack_require__(2971);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Webapi__Dom__Document = __webpack_require__(8416);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "x",
            Decco.floatToJson(v.x)
        ],
        [
            "y",
            Decco.floatToJson(v.y)
        ],
        [
            "width",
            Decco.floatToJson(v.width)
        ],
        [
            "height",
            Decco.floatToJson(v.height)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var x = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "x"), null));
    if (x.TAG === /* Ok */ 0) {
        var y = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "y"), null));
        if (y.TAG === /* Ok */ 0) {
            var width = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "width"), null));
            if (width.TAG === /* Ok */ 0) {
                var height = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "height"), null));
                if (height.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            x: x._0,
                            y: y._0,
                            width: width._0,
                            height: height._0
                        }
                    };
                }
                var e = height._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".height" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = width._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".width" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = y._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".y" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = x._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".x" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
function stringify(rect) {
    return JSON.stringify(rect);
}
function fromDomRect(rect) {
    return {
        x: rect.x,
        y: rect.y,
        width: rect.width,
        height: rect.height
    };
}
function centerX(param) {
    return param.x + param.width / 2.0;
}
function centerY(param) {
    return param.y + param.height / 2.0;
}
function diameter(param) {
    var h = param.height;
    var w = param.width;
    return Math.sqrt(w * w + h * h);
}
function resizeAtCenterPointToFit(maxWidth, maxHeight, rect) {
    return {
        x: centerX(rect) - maxWidth / 2.0,
        y: centerY(rect) - maxHeight / 2.0,
        width: maxWidth,
        height: maxHeight
    };
}
function scale(scale$1, rect) {
    return {
        x: rect.x * scale$1,
        y: rect.y * scale$1,
        width: rect.width * scale$1,
        height: rect.height * scale$1
    };
}
function withPadding(paddingInt, rect) {
    var padding = paddingInt;
    return {
        x: rect.x - padding,
        y: rect.y - padding,
        width: rect.width + padding * 2.0,
        height: rect.height + padding * 2.0
    };
}
function shift(dx, dy, rect) {
    return {
        x: rect.x + dx,
        y: rect.y + dy,
        width: rect.width,
        height: rect.height
    };
}
function ofContainingCircle(rect) {
    var d = diameter(rect);
    var r = d / 2.0;
    var x0 = centerX(rect);
    var y0 = centerY(rect);
    return {
        x: x0 - r,
        y: y0 - r,
        width: d,
        height: d
    };
}
function left(param) {
    return param.x;
}
function right(param) {
    return param.x + param.width;
}
function top(param) {
    return param.y;
}
function bottom(param) {
    return param.y + param.height;
}
function isEmpty(param) {
    if (param.width <= 0.0) {
        return true;
    } else {
        return param.height <= 0.0;
    }
}
function isNotEmpty(r) {
    return !isEmpty(r);
}
function fromPoints(left1, top1, right1, bottom1) {
    return {
        x: left1,
        y: top1,
        width: right1 - left1,
        height: bottom1 - top1
    };
}
function forDomTextNode(domText) {
    var domRange = document.createRange();
    domRange.selectNode(domText);
    var domRect = domRange.getBoundingClientRect();
    domRange.detach();
    var scrollX = window.scrollX;
    var scrollY = window.scrollY;
    return fromPoints(Math.floor(domRect.left + scrollX), Math.floor(domRect.top + scrollY), Math.ceil(domRect.right + scrollX), Math.ceil(domRect.bottom + scrollY));
}
function forHtmlElement(htmlElement) {
    var domRect = htmlElement.getBoundingClientRect();
    var scrollX = window.scrollX;
    var scrollY = window.scrollY;
    return fromPoints(Math.floor(domRect.left + scrollX), Math.floor(domRect.top + scrollY), Math.ceil(domRect.right + scrollX), Math.ceil(domRect.bottom + scrollY));
}
function forPage(param1) {
    var arg = Webapi__Dom__Document.asHtmlDocument(document);
    var htmlDocument = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
    }("Expect to get htmlDocument");
    var arg$1 = htmlDocument.body;
    var arg$2 = arg$1 == null ? undefined : Caml_option.some(arg$1);
    var body = function(param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
    }("Expect to get htmlDocument.body");
    return fromPoints(0.0, 0.0, body.scrollWidth, body.scrollHeight);
}
function clipRect(maybeLeft, maybeTop, maybeRight, maybeBottom, rect) {
    var partial_arg = left(rect);
    var arg = Belt_Option.map(maybeLeft, function(param) {
        return Math.max(partial_arg, param);
    });
    var partial_arg$1 = top(rect);
    var arg$1 = Belt_Option.map(maybeTop, function(param) {
        return Math.max(partial_arg$1, param);
    });
    var partial_arg$2 = right(rect);
    var arg$2 = Belt_Option.map(maybeRight, function(param) {
        return Math.min(partial_arg$2, param);
    });
    var partial_arg$3 = bottom(rect);
    var arg$3 = Belt_Option.map(maybeBottom, function(param) {
        return Math.min(partial_arg$3, param);
    });
    return fromPoints(function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }(left(rect)), function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
    }(top(rect)), function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg$2);
    }(right(rect)), function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg$3);
    }(bottom(rect)));
}
function boundingRect2(r1, r2) {
    return fromPoints(Math.min(left(r1), left(r2)), Math.min(top(r1), top(r2)), Math.max(right(r1), right(r2)), Math.max(bottom(r1), bottom(r2)));
}
function boundingRectMany(rects) {
    var match = ArrayUtils$SmartcutsMacros.splitAtFirstExn("Expect at least 1 rect when calculating boundingRectMany", rects);
    return Belt_Array.reduce(match[1], match[0], boundingRect2);
}
function intersect(rect1, rect2) {
    var x1 = Math.max(left(rect1), left(rect2));
    var x2 = Math.min(right(rect1), right(rect2));
    var y1 = Math.max(top(rect1), top(rect2));
    var y2 = Math.min(bottom(rect1), bottom(rect2));
    return {
        x: x1,
        y: y1,
        width: Math.max(0.0, x2 - x1),
        height: Math.max(0.0, y2 - y1)
    };
}
function containsPoint(x, y, rect) {
    if (x >= rect.x && x <= rect.x + rect.width && y >= rect.y) {
        return y <= rect.y + rect.height;
    } else {
        return false;
    }
}
function doesNotIntersectWith(r1, r2) {
    return isEmpty(intersect(r1, r2));
}
function doesIntersectWith(r1, r2) {
    var r = intersect(r1, r2);
    return !isEmpty(r);
}
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.stringify = stringify;
exports.fromDomRect = fromDomRect;
exports.centerX = centerX;
exports.centerY = centerY;
exports.diameter = diameter;
exports.resizeAtCenterPointToFit = resizeAtCenterPointToFit;
exports.scale = scale;
exports.withPadding = withPadding;
exports.shift = shift;
exports.ofContainingCircle = ofContainingCircle;
exports.left = left;
exports.right = right;
exports.top = top;
exports.bottom = bottom;
exports.isEmpty = isEmpty;
exports.isNotEmpty = isNotEmpty;
exports.fromPoints = fromPoints;
exports.forDomTextNode = forDomTextNode;
exports.forHtmlElement = forHtmlElement;
exports.forPage = forPage;
exports.clipRect = clipRect;
exports.boundingRect2 = boundingRect2;
exports.boundingRectMany = boundingRectMany;
exports.intersect = intersect;
exports.containsPoint = containsPoint;
exports.doesNotIntersectWith = doesNotIntersectWith;
exports.doesIntersectWith = doesIntersectWith; /* Webapi__Dom__Document Not a pure module */ 


/***/ }),

/***/ 12913:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Caml_option = __webpack_require__(57175);
var Json_decode = __webpack_require__(50957);
var Log$SmartcutsMacros = __webpack_require__(78088);
var DebugUtils$SmartcutsMacros = __webpack_require__(10413);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var Browser__Tabs$SmartcutsMacros = __webpack_require__(13468);
function consoleWarnTabWithMaybeTabId(maybeTabId) {
    if (maybeTabId !== undefined) {
        return Browser__Tabs$SmartcutsMacros.get(maybeTabId).then(function(tab) {
            console.warn(Browser__Tabs$SmartcutsMacros.Tab.toShortString(tab), tab);
            return Promise.resolve(undefined);
        });
    } else {
        return Promise.resolve(undefined);
    }
}
function t_encode(prim) {
    return prim;
}
function t_decode(json) {
    return {
        TAG: /* Ok */ 0,
        _0: json
    };
}
var Debuggee = {
    t_encode: t_encode,
    t_decode: t_decode
};
var Attach = {};
function attach(maybeTabId, extensionId, targetId, version) {
    return new Promise(function(resolve, reject) {
        var tmp = {};
        if (maybeTabId !== undefined) {
            tmp.tabId = Caml_option.valFromOption(maybeTabId);
        }
        if (extensionId !== undefined) {
            tmp.extensionId = Caml_option.valFromOption(extensionId);
        }
        if (targetId !== undefined) {
            tmp.targetId = Caml_option.valFromOption(targetId);
        }
        var debuggee = tmp;
        chrome.debugger.attach(debuggee, version, function(param) {
            var jsExn = browser.runtime.lastError;
            if (jsExn == null) {
                return resolve(1);
            } else {
                console.warn("Got error for (tabId, extensionId, targetId)=", [
                    maybeTabId,
                    extensionId,
                    targetId
                ]);
                console.error("runtime.lastError inside chrome.debugger.attach", jsExn.name, jsExn.message, jsExn);
                consoleWarnTabWithMaybeTabId(maybeTabId);
                return reject(jsExn);
            }
        });
    }).then(function(param) {
        return Promise.resolve(undefined);
    });
}
var SendCommand = {};
function sendCommand(maybeTabId, extensionId, targetId, command, params) {
    var tmp = {};
    if (maybeTabId !== undefined) {
        tmp.tabId = Caml_option.valFromOption(maybeTabId);
    }
    if (extensionId !== undefined) {
        tmp.extensionId = Caml_option.valFromOption(extensionId);
    }
    if (targetId !== undefined) {
        tmp.targetId = Caml_option.valFromOption(targetId);
    }
    var debuggee = tmp;
    var stack = DebugUtils$SmartcutsMacros.getCurrStack(undefined);
    return new Promise(function(resolve, reject) {
        chrome.debugger.sendCommand(debuggee, command, params, function(maybeResult) {
            if (maybeResult !== undefined) {
                return resolve(Caml_option.nullable_to_opt(Caml_option.valFromOption(maybeResult)));
            }
            var jsExn = browser.runtime.lastError;
            if (jsExn == null) {
                console.warn("Got neither result not browser.runtime.lastError");
                return resolve(undefined);
            }
            var match = jsExn.message;
            var exit = 0;
            if (match !== '{"code":-32000,"message":"Could not compute box model."}') {
                exit = 1;
            }
            if (exit === 1) {
                console.warn("Got error for (tabId, extensionId, targetId, command)=", [
                    maybeTabId,
                    extensionId,
                    targetId,
                    command
                ]);
                var arg = OptionUtils$SmartcutsMacros.map(jsExn.name, function(name) {
                    return name + ": ";
                });
                var arg$1 = jsExn.message;
                console.error("runtime.lastError inside chrome.debugger.sendCommand", function(param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                }("") + function(param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                }(""), command, stack);
                consoleWarnTabWithMaybeTabId(maybeTabId);
            }
            return reject(jsExn);
        });
    });
}
var Detach = {};
function detach(tabId, extensionId, targetId, param) {
    var tmp = {};
    if (tabId !== undefined) {
        tmp.tabId = Caml_option.valFromOption(tabId);
    }
    if (extensionId !== undefined) {
        tmp.extensionId = Caml_option.valFromOption(extensionId);
    }
    if (targetId !== undefined) {
        tmp.targetId = Caml_option.valFromOption(targetId);
    }
    var debuggee = tmp;
    return new Promise(function(resolve, param) {
        Curry._3(Log$SmartcutsMacros.playback.log3, "DETACHED!", tabId, browser.runtime.lastError);
        chrome.debugger.detach(debuggee, function(param) {
            return resolve(1);
        });
    }).then(function(param) {
        return Promise.resolve(undefined);
    });
}
var _map = {
    "Target_closed": "target_closed",
    "Canceled_by_user": "canceled_by_user"
};
var _revMap = {
    "target_closed": "Target_closed",
    "canceled_by_user": "Canceled_by_user"
};
function tToJs(param) {
    return _map[param];
}
function tFromJs(param) {
    return _revMap[param];
}
function t_encode$1(t) {
    return _map[t];
}
function t_decode$1(json) {
    var t = _revMap[Json_decode.string(json)];
    if (t !== undefined) {
        return {
            TAG: /* Ok */ 0,
            _0: t
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: {
                path: "",
                message: "failed to convert detachReason",
                value: json
            }
        };
    }
}
var DetachReason = {
    tToJs: tToJs,
    tFromJs: tFromJs,
    t_encode: t_encode$1,
    t_decode: t_decode$1
};
var OnDetach = {};
exports.consoleWarnTabWithMaybeTabId = consoleWarnTabWithMaybeTabId;
exports.Debuggee = Debuggee;
exports.Attach = Attach;
exports.attach = attach;
exports.SendCommand = SendCommand;
exports.sendCommand = sendCommand;
exports.Detach = Detach;
exports.detach = detach;
exports.DetachReason = DetachReason;
exports.OnDetach = OnDetach; /* Log-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 13468:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Image$SmartcutsMacros = __webpack_require__(68387);
var DeccoUtils$SmartcutsMacros = __webpack_require__(52567);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var _map = {
    "loading": "loading",
    "complete": "complete",
    "unloaded": "unloaded"
};
function tToJs(param) {
    return param;
}
function tFromJs(param) {
    return _map[param];
}
var Status = DeccoUtils$SmartcutsMacros.MakePolymorphicWithDeccoFns({
    typeName: "Browser.Tabs.Tab.Status.t",
    tToJs: tToJs,
    tFromJs: tFromJs
});
var include = DeccoUtils$SmartcutsMacros.MakeDerivingAbstractDeccoFns({});
var TabWithStringStatus = include;
function t_encode(v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.optionToJson(Decco.intToJson, v.id)
        ],
        [
            "index",
            Decco.intToJson(v.index)
        ],
        [
            "windowId",
            Decco.intToJson(v.windowId)
        ],
        [
            "openerTabId",
            Decco.optionToJson(Decco.intToJson, v.openerTabId)
        ],
        [
            "highlighted",
            Decco.boolToJson(v.highlighted)
        ],
        [
            "active",
            Decco.boolToJson(v.active)
        ],
        [
            "pinned",
            Decco.boolToJson(v.pinned)
        ],
        [
            "audible",
            Decco.optionToJson(Decco.boolToJson, v.audible)
        ],
        [
            "discarded",
            Decco.boolToJson(v.discarded)
        ],
        [
            "autoDiscardable",
            Decco.boolToJson(v.autoDiscardable)
        ],
        [
            "url",
            Decco.optionToJson(Decco.stringToJson, v.url)
        ],
        [
            "pendingUrl",
            Decco.optionToJson(Decco.stringToJson, v.pendingUrl)
        ],
        [
            "title",
            Decco.optionToJson(Decco.stringToJson, v.title)
        ],
        [
            "favIconUrl",
            Decco.optionToJson(Decco.stringToJson, v.favIconUrl)
        ],
        [
            "status",
            Decco.optionToJson(Status.t_encode, v.status)
        ],
        [
            "incognito",
            Decco.boolToJson(v.incognito)
        ],
        [
            "width",
            Decco.optionToJson(Decco.intToJson, v.width)
        ],
        [
            "height",
            Decco.optionToJson(Decco.intToJson, v.height)
        ],
        [
            "sessionId",
            Decco.optionToJson(Decco.stringToJson, v.sessionId)
        ]
    ]);
}
function t_decode(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var index = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "index"), null));
        if (index.TAG === /* Ok */ 0) {
            var windowId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowId"), null));
            if (windowId.TAG === /* Ok */ 0) {
                var openerTabId = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "openerTabId"), null));
                if (openerTabId.TAG === /* Ok */ 0) {
                    var highlighted = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "highlighted"), null));
                    if (highlighted.TAG === /* Ok */ 0) {
                        var active = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "active"), null));
                        if (active.TAG === /* Ok */ 0) {
                            var pinned = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pinned"), null));
                            if (pinned.TAG === /* Ok */ 0) {
                                var audible = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "audible"), null));
                                if (audible.TAG === /* Ok */ 0) {
                                    var discarded = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "discarded"), null));
                                    if (discarded.TAG === /* Ok */ 0) {
                                        var autoDiscardable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "autoDiscardable"), null));
                                        if (autoDiscardable.TAG === /* Ok */ 0) {
                                            var url = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
                                            if (url.TAG === /* Ok */ 0) {
                                                var pendingUrl = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pendingUrl"), null));
                                                if (pendingUrl.TAG === /* Ok */ 0) {
                                                    var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
                                                    if (title.TAG === /* Ok */ 0) {
                                                        var favIconUrl = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "favIconUrl"), null));
                                                        if (favIconUrl.TAG === /* Ok */ 0) {
                                                            var status = Decco.optionFromJson(Status.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
                                                            if (status.TAG === /* Ok */ 0) {
                                                                var incognito = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "incognito"), null));
                                                                if (incognito.TAG === /* Ok */ 0) {
                                                                    var width = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "width"), null));
                                                                    if (width.TAG === /* Ok */ 0) {
                                                                        var height = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "height"), null));
                                                                        if (height.TAG === /* Ok */ 0) {
                                                                            var sessionId = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sessionId"), null));
                                                                            if (sessionId.TAG === /* Ok */ 0) {
                                                                                return {
                                                                                    TAG: /* Ok */ 0,
                                                                                    _0: {
                                                                                        id: id._0,
                                                                                        index: index._0,
                                                                                        windowId: windowId._0,
                                                                                        openerTabId: openerTabId._0,
                                                                                        highlighted: highlighted._0,
                                                                                        active: active._0,
                                                                                        pinned: pinned._0,
                                                                                        audible: audible._0,
                                                                                        discarded: discarded._0,
                                                                                        autoDiscardable: autoDiscardable._0,
                                                                                        url: url._0,
                                                                                        pendingUrl: pendingUrl._0,
                                                                                        title: title._0,
                                                                                        favIconUrl: favIconUrl._0,
                                                                                        status: status._0,
                                                                                        incognito: incognito._0,
                                                                                        width: width._0,
                                                                                        height: height._0,
                                                                                        sessionId: sessionId._0
                                                                                    }
                                                                                };
                                                                            }
                                                                            var e = sessionId._0;
                                                                            return {
                                                                                TAG: /* Error */ 1,
                                                                                _0: {
                                                                                    path: ".sessionId" + e.path,
                                                                                    message: e.message,
                                                                                    value: e.value
                                                                                }
                                                                            };
                                                                        }
                                                                        var e$1 = height._0;
                                                                        return {
                                                                            TAG: /* Error */ 1,
                                                                            _0: {
                                                                                path: ".height" + e$1.path,
                                                                                message: e$1.message,
                                                                                value: e$1.value
                                                                            }
                                                                        };
                                                                    }
                                                                    var e$2 = width._0;
                                                                    return {
                                                                        TAG: /* Error */ 1,
                                                                        _0: {
                                                                            path: ".width" + e$2.path,
                                                                            message: e$2.message,
                                                                            value: e$2.value
                                                                        }
                                                                    };
                                                                }
                                                                var e$3 = incognito._0;
                                                                return {
                                                                    TAG: /* Error */ 1,
                                                                    _0: {
                                                                        path: ".incognito" + e$3.path,
                                                                        message: e$3.message,
                                                                        value: e$3.value
                                                                    }
                                                                };
                                                            }
                                                            var e$4 = status._0;
                                                            return {
                                                                TAG: /* Error */ 1,
                                                                _0: {
                                                                    path: ".status" + e$4.path,
                                                                    message: e$4.message,
                                                                    value: e$4.value
                                                                }
                                                            };
                                                        }
                                                        var e$5 = favIconUrl._0;
                                                        return {
                                                            TAG: /* Error */ 1,
                                                            _0: {
                                                                path: ".favIconUrl" + e$5.path,
                                                                message: e$5.message,
                                                                value: e$5.value
                                                            }
                                                        };
                                                    }
                                                    var e$6 = title._0;
                                                    return {
                                                        TAG: /* Error */ 1,
                                                        _0: {
                                                            path: ".title" + e$6.path,
                                                            message: e$6.message,
                                                            value: e$6.value
                                                        }
                                                    };
                                                }
                                                var e$7 = pendingUrl._0;
                                                return {
                                                    TAG: /* Error */ 1,
                                                    _0: {
                                                        path: ".pendingUrl" + e$7.path,
                                                        message: e$7.message,
                                                        value: e$7.value
                                                    }
                                                };
                                            }
                                            var e$8 = url._0;
                                            return {
                                                TAG: /* Error */ 1,
                                                _0: {
                                                    path: ".url" + e$8.path,
                                                    message: e$8.message,
                                                    value: e$8.value
                                                }
                                            };
                                        }
                                        var e$9 = autoDiscardable._0;
                                        return {
                                            TAG: /* Error */ 1,
                                            _0: {
                                                path: ".autoDiscardable" + e$9.path,
                                                message: e$9.message,
                                                value: e$9.value
                                            }
                                        };
                                    }
                                    var e$10 = discarded._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".discarded" + e$10.path,
                                            message: e$10.message,
                                            value: e$10.value
                                        }
                                    };
                                }
                                var e$11 = audible._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".audible" + e$11.path,
                                        message: e$11.message,
                                        value: e$11.value
                                    }
                                };
                            }
                            var e$12 = pinned._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".pinned" + e$12.path,
                                    message: e$12.message,
                                    value: e$12.value
                                }
                            };
                        }
                        var e$13 = active._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".active" + e$13.path,
                                message: e$13.message,
                                value: e$13.value
                            }
                        };
                    }
                    var e$14 = highlighted._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".highlighted" + e$14.path,
                            message: e$14.message,
                            value: e$14.value
                        }
                    };
                }
                var e$15 = openerTabId._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".openerTabId" + e$15.path,
                        message: e$15.message,
                        value: e$15.value
                    }
                };
            }
            var e$16 = windowId._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".windowId" + e$16.path,
                    message: e$16.message,
                    value: e$16.value
                }
            };
        }
        var e$17 = index._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".index" + e$17.path,
                message: e$17.message,
                value: e$17.value
            }
        };
    }
    var e$18 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$18.path,
            message: e$18.message,
            value: e$18.value
        }
    };
}
function fromJs(tab) {
    var status = tab.status;
    return {
        id: Caml_option.undefined_to_opt(tab.id),
        index: tab.index,
        windowId: tab.windowId,
        openerTabId: Caml_option.undefined_to_opt(tab.openerTabId),
        highlighted: tab.highlighted,
        active: tab.active,
        pinned: tab.pinned,
        audible: Caml_option.undefined_to_opt(tab.audible),
        discarded: tab.discarded,
        autoDiscardable: tab.autoDiscardable,
        url: Caml_option.undefined_to_opt(tab.url),
        pendingUrl: Caml_option.undefined_to_opt(tab.pendingUrl),
        title: Caml_option.undefined_to_opt(tab.title),
        favIconUrl: Caml_option.undefined_to_opt(tab.favIconUrl),
        status: status !== undefined ? Curry._1(Status.tFromJs, status) : undefined,
        incognito: tab.incognito,
        width: Caml_option.undefined_to_opt(tab.width),
        height: Caml_option.undefined_to_opt(tab.height),
        sessionId: Caml_option.undefined_to_opt(tab.sessionId)
    };
}
function toJs(tab) {
    var status = tab.status;
    var tmp = {
        index: tab.index,
        windowId: tab.windowId,
        highlighted: tab.highlighted,
        active: tab.active,
        pinned: tab.pinned,
        discarded: tab.discarded,
        autoDiscardable: tab.autoDiscardable,
        incognito: tab.incognito
    };
    if (tab.id !== undefined) {
        tmp.id = Caml_option.valFromOption(tab.id);
    }
    if (tab.openerTabId !== undefined) {
        tmp.openerTabId = Caml_option.valFromOption(tab.openerTabId);
    }
    if (tab.audible !== undefined) {
        tmp.audible = Caml_option.valFromOption(tab.audible);
    }
    if (tab.url !== undefined) {
        tmp.url = Caml_option.valFromOption(tab.url);
    }
    if (tab.pendingUrl !== undefined) {
        tmp.pendingUrl = Caml_option.valFromOption(tab.pendingUrl);
    }
    if (tab.title !== undefined) {
        tmp.title = Caml_option.valFromOption(tab.title);
    }
    if (tab.favIconUrl !== undefined) {
        tmp.favIconUrl = Caml_option.valFromOption(tab.favIconUrl);
    }
    var tmp$1 = status !== undefined ? Curry._1(Status.tToJs, status) : undefined;
    if (tmp$1 !== undefined) {
        tmp.status = Caml_option.valFromOption(tmp$1);
    }
    if (tab.width !== undefined) {
        tmp.width = Caml_option.valFromOption(tab.width);
    }
    if (tab.height !== undefined) {
        tmp.height = Caml_option.valFromOption(tab.height);
    }
    if (tab.sessionId !== undefined) {
        tmp.sessionId = Caml_option.valFromOption(tab.sessionId);
    }
    return tmp;
}
function wasOpenedByTabId(tabId, tab) {
    return OptionUtils$SmartcutsMacros.equalsSome(tabId, tab.openerTabId);
}
function toShortString(tab) {
    var arg = tab.url;
    var tabUrl = function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
    }("undefined");
    var arg$1 = OptionUtils$SmartcutsMacros.map(tab.id, function(prim) {
        return String(prim);
    });
    var tabId = function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
    }("undefined");
    var windowId = String(tab.windowId);
    var arg$2 = OptionUtils$SmartcutsMacros.map(tab.openerTabId, function(openerTabId) {
        return ", openerTabId=" + String(openerTabId);
    });
    var openerTabIdString = function(param) {
        return OptionUtils$SmartcutsMacros.withDefault(param, arg$2);
    }("");
    return "tab(id=" + tabId + ", window=" + windowId + ", url=" + tabUrl + (openerTabIdString + ")");
}
var Tab = {
    Status: Status,
    TabWithStringStatus: TabWithStringStatus,
    t_encode: t_encode,
    t_decode: t_decode,
    fromJs: fromJs,
    toJs: toJs,
    wasOpenedByTabId: wasOpenedByTabId,
    toShortString: toShortString
};
var ReloadProperties = {};
var _map$1 = {
    "DocumentStart": "document_start",
    "DocumentEnd": "document_end",
    "DocumentIdle": "document_idle"
};
function runAtToJs(param) {
    return _map$1[param];
}
function file(frame, matchAboutBlank, runAt, file$1) {
    var match = frame !== undefined ? frame ? [
        undefined,
        frame._0
    ] : [
        true,
        undefined
    ] : [
        undefined,
        undefined
    ];
    var tmp = {
        file: file$1
    };
    var tmp$1 = match[0];
    if (tmp$1 !== undefined) {
        tmp.allFrames = Caml_option.valFromOption(tmp$1);
    }
    var tmp$2 = match[1];
    if (tmp$2 !== undefined) {
        tmp.frameId = Caml_option.valFromOption(tmp$2);
    }
    if (matchAboutBlank !== undefined) {
        tmp.matchAboutBlank = Caml_option.valFromOption(matchAboutBlank);
    }
    var tmp$3 = Belt_Option.map(runAt, runAtToJs);
    if (tmp$3 !== undefined) {
        tmp.runAt = Caml_option.valFromOption(tmp$3);
    }
    return tmp;
}
var ExecuteScriptContext = {
    file: file
};
var SendMessageOptions = {};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "tabId",
            Decco.intToJson(v.tabId)
        ],
        [
            "windowId",
            Decco.intToJson(v.windowId)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
    if (tabId.TAG === /* Ok */ 0) {
        var windowId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowId"), null));
        if (windowId.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    tabId: tabId._0,
                    windowId: windowId._0
                }
            };
        }
        var e = windowId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".windowId" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = tabId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".tabId" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var ActiveInfo = {
    t_encode: t_encode$1,
    t_decode: t_decode$1
};
var OnActivated = {
    ActiveInfo: ActiveInfo
};
var OnCreated = {};
var _map$2 = {
    "user": "user",
    "capture": "capture",
    "extension": "extension"
};
function tToJs$1(param) {
    return param;
}
function tFromJs$1(param) {
    return _map$2[param];
}
var MutedInfoReason = DeccoUtils$SmartcutsMacros.MakePolymorphicWithDeccoFns({
    typeName: "Browser.Tabs.OnUpdated.MutedInfo.MutedInfoReason.t",
    tToJs: tToJs$1,
    tFromJs: tFromJs$1
});
var include$1 = DeccoUtils$SmartcutsMacros.MakeDerivingAbstractDeccoFns({});
var t_encode$2 = include$1.t_encode;
var t_decode$2 = include$1.t_decode;
var MutedInfo = {
    MutedInfoReason: MutedInfoReason,
    t_encode: t_encode$2,
    t_decode: t_decode$2
};
var include$2 = DeccoUtils$SmartcutsMacros.MakeDerivingAbstractDeccoFns({});
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "status",
            Decco.optionToJson(Status.t_encode, v.status)
        ],
        [
            "url",
            Decco.optionToJson(Decco.stringToJson, v.url)
        ],
        [
            "pinned",
            Decco.optionToJson(Decco.boolToJson, v.pinned)
        ],
        [
            "audible",
            Decco.optionToJson(Decco.boolToJson, v.audible)
        ],
        [
            "discarded",
            Decco.optionToJson(Decco.boolToJson, v.discarded)
        ],
        [
            "autoDiscardable",
            Decco.optionToJson(Decco.boolToJson, v.autoDiscardable)
        ],
        [
            "mutedInfo",
            Decco.optionToJson(t_encode$2, v.mutedInfo)
        ],
        [
            "favIconUrl",
            Decco.optionToJson(Decco.stringToJson, v.favIconUrl)
        ],
        [
            "title",
            Decco.optionToJson(Decco.stringToJson, v.title)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var status = Decco.optionFromJson(Status.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
    if (status.TAG === /* Ok */ 0) {
        var url = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
        if (url.TAG === /* Ok */ 0) {
            var pinned = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pinned"), null));
            if (pinned.TAG === /* Ok */ 0) {
                var audible = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "audible"), null));
                if (audible.TAG === /* Ok */ 0) {
                    var discarded = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "discarded"), null));
                    if (discarded.TAG === /* Ok */ 0) {
                        var autoDiscardable = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "autoDiscardable"), null));
                        if (autoDiscardable.TAG === /* Ok */ 0) {
                            var mutedInfo = Decco.optionFromJson(t_decode$2, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mutedInfo"), null));
                            if (mutedInfo.TAG === /* Ok */ 0) {
                                var favIconUrl = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "favIconUrl"), null));
                                if (favIconUrl.TAG === /* Ok */ 0) {
                                    var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
                                    if (title.TAG === /* Ok */ 0) {
                                        return {
                                            TAG: /* Ok */ 0,
                                            _0: {
                                                status: status._0,
                                                url: url._0,
                                                pinned: pinned._0,
                                                audible: audible._0,
                                                discarded: discarded._0,
                                                autoDiscardable: autoDiscardable._0,
                                                mutedInfo: mutedInfo._0,
                                                favIconUrl: favIconUrl._0,
                                                title: title._0
                                            }
                                        };
                                    }
                                    var e = title._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".title" + e.path,
                                            message: e.message,
                                            value: e.value
                                        }
                                    };
                                }
                                var e$1 = favIconUrl._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".favIconUrl" + e$1.path,
                                        message: e$1.message,
                                        value: e$1.value
                                    }
                                };
                            }
                            var e$2 = mutedInfo._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".mutedInfo" + e$2.path,
                                    message: e$2.message,
                                    value: e$2.value
                                }
                            };
                        }
                        var e$3 = autoDiscardable._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".autoDiscardable" + e$3.path,
                                message: e$3.message,
                                value: e$3.value
                            }
                        };
                    }
                    var e$4 = discarded._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".discarded" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = audible._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".audible" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            }
            var e$6 = pinned._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".pinned" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                }
            };
        }
        var e$7 = url._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".url" + e$7.path,
                message: e$7.message,
                value: e$7.value
            }
        };
    }
    var e$8 = status._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".status" + e$8.path,
            message: e$8.message,
            value: e$8.value
        }
    };
}
function didAnythingChange(record) {
    return Caml_obj.caml_notequal(record, {
        status: undefined,
        url: undefined,
        pinned: undefined,
        audible: undefined,
        discarded: undefined,
        autoDiscardable: undefined,
        mutedInfo: undefined,
        favIconUrl: undefined,
        title: undefined
    });
}
function calculateForTabBeforeAndAfter(tabA, tabB) {
    return {
        status: Caml_obj.caml_equal(tabA.status, tabB.status) ? undefined : tabB.status,
        url: Caml_obj.caml_equal(tabA.url, tabB.url) ? undefined : tabB.url,
        pinned: tabA.pinned === tabB.pinned ? undefined : tabB.pinned,
        audible: Caml_obj.caml_equal(tabA.audible, tabB.audible) ? undefined : tabB.audible,
        discarded: tabA.discarded === tabB.discarded ? undefined : tabB.discarded,
        autoDiscardable: undefined,
        mutedInfo: undefined,
        favIconUrl: Caml_obj.caml_equal(tabA.favIconUrl, tabB.favIconUrl) ? undefined : tabB.favIconUrl,
        title: Caml_obj.caml_equal(tabA.title, tabB.title) ? undefined : tabB.title
    };
}
var Record = {
    t_encode: t_encode$3,
    t_decode: t_decode$3,
    didAnythingChange: didAnythingChange,
    calculateForTabBeforeAndAfter: calculateForTabBeforeAndAfter
};
function toRecord(changeInfo) {
    var str = changeInfo.status;
    return {
        status: str !== undefined ? Curry._1(Status.tFromJs, str) : undefined,
        url: Caml_option.undefined_to_opt(changeInfo.url),
        pinned: Caml_option.undefined_to_opt(changeInfo.pinned),
        audible: Caml_option.undefined_to_opt(changeInfo.audible),
        discarded: Caml_option.undefined_to_opt(changeInfo.discarded),
        autoDiscardable: Caml_option.undefined_to_opt(changeInfo.autoDiscardable),
        mutedInfo: Caml_option.undefined_to_opt(changeInfo.mutedInfo),
        favIconUrl: Caml_option.undefined_to_opt(changeInfo.favIconUrl),
        title: Caml_option.undefined_to_opt(changeInfo.title)
    };
}
function fromRecord(record) {
    var tmp = {};
    var tmp$1 = OptionUtils$SmartcutsMacros.map(record.status, Status.tToJs);
    if (tmp$1 !== undefined) {
        tmp.status = Caml_option.valFromOption(tmp$1);
    }
    if (record.url !== undefined) {
        tmp.url = Caml_option.valFromOption(record.url);
    }
    if (record.pinned !== undefined) {
        tmp.pinned = Caml_option.valFromOption(record.pinned);
    }
    if (record.audible !== undefined) {
        tmp.audible = Caml_option.valFromOption(record.audible);
    }
    if (record.discarded !== undefined) {
        tmp.discarded = Caml_option.valFromOption(record.discarded);
    }
    if (record.autoDiscardable !== undefined) {
        tmp.autoDiscardable = Caml_option.valFromOption(record.autoDiscardable);
    }
    if (record.mutedInfo !== undefined) {
        tmp.mutedInfo = Caml_option.valFromOption(record.mutedInfo);
    }
    if (record.favIconUrl !== undefined) {
        tmp.favIconUrl = Caml_option.valFromOption(record.favIconUrl);
    }
    if (record.title !== undefined) {
        tmp.title = Caml_option.valFromOption(record.title);
    }
    return tmp;
}
function stringify(changeInfo) {
    return JSON.stringify(fromRecord(changeInfo));
}
var ChangeInfo_t_encode = include$2.t_encode;
var ChangeInfo_t_decode = include$2.t_decode;
var ChangeInfo = {
    t_encode: ChangeInfo_t_encode,
    t_decode: ChangeInfo_t_decode,
    Record: Record,
    toRecord: toRecord,
    fromRecord: fromRecord,
    stringify: stringify
};
var OnUpdated = {
    MutedInfo: MutedInfo,
    ChangeInfo: ChangeInfo
};
function t_encode$4(v) {
    return Js_dict.fromArray([
        [
            "windowId",
            Decco.intToJson(v.windowId)
        ],
        [
            "isWindowClosing",
            Decco.boolToJson(v.isWindowClosing)
        ]
    ]);
}
function t_decode$4(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var windowId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowId"), null));
    if (windowId.TAG === /* Ok */ 0) {
        var isWindowClosing = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isWindowClosing"), null));
        if (isWindowClosing.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    windowId: windowId._0,
                    isWindowClosing: isWindowClosing._0
                }
            };
        }
        var e = isWindowClosing._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".isWindowClosing" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = windowId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".windowId" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var RemoveInfo = {
    t_encode: t_encode$4,
    t_decode: t_decode$4
};
var OnRemoved = {
    RemoveInfo: RemoveInfo
};
function t_encode$5(v) {
    return Js_dict.fromArray([
        [
            "windowId",
            Decco.intToJson(v.windowId)
        ],
        [
            "fromIndex",
            Decco.intToJson(v.fromIndex)
        ],
        [
            "toIndex",
            Decco.intToJson(v.toIndex)
        ]
    ]);
}
function t_decode$5(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var windowId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "windowId"), null));
    if (windowId.TAG === /* Ok */ 0) {
        var fromIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fromIndex"), null));
        if (fromIndex.TAG === /* Ok */ 0) {
            var toIndex = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "toIndex"), null));
            if (toIndex.TAG === /* Ok */ 0) {
                return {
                    TAG: /* Ok */ 0,
                    _0: {
                        windowId: windowId._0,
                        fromIndex: fromIndex._0,
                        toIndex: toIndex._0
                    }
                };
            }
            var e = toIndex._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".toIndex" + e.path,
                    message: e.message,
                    value: e.value
                }
            };
        }
        var e$1 = fromIndex._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".fromIndex" + e$1.path,
                message: e$1.message,
                value: e$1.value
            }
        };
    }
    var e$2 = windowId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".windowId" + e$2.path,
            message: e$2.message,
            value: e$2.value
        }
    };
}
var MoveInfo = {
    t_encode: t_encode$5,
    t_decode: t_decode$5
};
var OnMoved = {
    MoveInfo: MoveInfo
};
function t_encode$6(v) {
    return Js_dict.fromArray([
        [
            "oldWindowId",
            Decco.intToJson(v.oldWindowId)
        ],
        [
            "oldPosition",
            Decco.intToJson(v.oldPosition)
        ]
    ]);
}
function t_decode$6(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var oldWindowId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "oldWindowId"), null));
    if (oldWindowId.TAG === /* Ok */ 0) {
        var oldPosition = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "oldPosition"), null));
        if (oldPosition.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    oldWindowId: oldWindowId._0,
                    oldPosition: oldPosition._0
                }
            };
        }
        var e = oldPosition._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".oldPosition" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = oldWindowId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".oldWindowId" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var DetachInfo = {
    t_encode: t_encode$6,
    t_decode: t_decode$6
};
var OnDetached = {
    DetachInfo: DetachInfo
};
function t_encode$7(v) {
    return Js_dict.fromArray([
        [
            "newWindowId",
            Decco.intToJson(v.newWindowId)
        ],
        [
            "newPosition",
            Decco.intToJson(v.newPosition)
        ]
    ]);
}
function t_decode$7(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var newWindowId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "newWindowId"), null));
    if (newWindowId.TAG === /* Ok */ 0) {
        var newPosition = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "newPosition"), null));
        if (newPosition.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    newWindowId: newWindowId._0,
                    newPosition: newPosition._0
                }
            };
        }
        var e = newPosition._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".newPosition" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = newWindowId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".newWindowId" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var AttachInfo = {
    t_encode: t_encode$7,
    t_decode: t_decode$7
};
var OnAttached = {
    AttachInfo: AttachInfo
};
var OnReplaced = {};
var _map$3 = {
    "automatic": "automatic",
    "manual": "manual",
    "disabled": "disabled"
};
function modeToJs(param) {
    return param;
}
function modeFromJs(param) {
    return _map$3[param];
}
var _map$4 = {
    "perOrigin": "per-origin",
    "perTab": "per-tab"
};
var _revMap = {
    "per-origin": "perOrigin",
    "per-tab": "perTab"
};
function scopeToJs(param) {
    return _map$4[param];
}
function scopeFromJs(param) {
    return _revMap[param];
}
var ZoomSettings = {
    modeToJs: modeToJs,
    modeFromJs: modeFromJs,
    scopeToJs: scopeToJs,
    scopeFromJs: scopeFromJs
};
var ZoomChangeInfo = {};
var OnZoomChange = {
    ZoomSettings: ZoomSettings,
    ZoomChangeInfo: ZoomChangeInfo
};
var Create = {};
function create(windowId, index, url, active, selected, pinned, openerTabId, param) {
    var tmp = {};
    if (windowId !== undefined) {
        tmp.windowId = Caml_option.valFromOption(windowId);
    }
    if (index !== undefined) {
        tmp.index = Caml_option.valFromOption(index);
    }
    if (url !== undefined) {
        tmp.url = Caml_option.valFromOption(url);
    }
    if (active !== undefined) {
        tmp.active = Caml_option.valFromOption(active);
    }
    if (selected !== undefined) {
        tmp.selected = Caml_option.valFromOption(selected);
    }
    if (pinned !== undefined) {
        tmp.pinned = Caml_option.valFromOption(pinned);
    }
    if (openerTabId !== undefined) {
        tmp.openerTabId = Caml_option.valFromOption(openerTabId);
    }
    return browser.tabs.create(tmp);
}
function get(tabId) {
    return browser.tabs.get(tabId).then(function(tab) {
        return Promise.resolve(fromJs(tab));
    });
}
var Update = {};
var _map$5 = {
    "normal": "normal",
    "popup": "popup",
    "panel": "panel",
    "app": "app",
    "devtools": "devtools"
};
function windowTypeToJs(param) {
    return param;
}
function windowTypeFromJs(param) {
    return _map$5[param];
}
var QueryInfoWithStringStatusAndWindowType = {};
var QueryInfo = {
    QueryInfoWithStringStatusAndWindowType: QueryInfoWithStringStatusAndWindowType
};
function updateTab(tabId, url, active, highlighted, pinned, muted, openerTabId, autoDiscardable, param) {
    var tmp = {};
    if (url !== undefined) {
        tmp.url = Caml_option.valFromOption(url);
    }
    if (active !== undefined) {
        tmp.active = Caml_option.valFromOption(active);
    }
    if (highlighted !== undefined) {
        tmp.highlighted = Caml_option.valFromOption(highlighted);
    }
    if (pinned !== undefined) {
        tmp.pinned = Caml_option.valFromOption(pinned);
    }
    if (muted !== undefined) {
        tmp.muted = Caml_option.valFromOption(muted);
    }
    if (openerTabId !== undefined) {
        tmp.openerTabId = Caml_option.valFromOption(openerTabId);
    }
    if (autoDiscardable !== undefined) {
        tmp.autoDiscardable = Caml_option.valFromOption(autoDiscardable);
    }
    return browser.tabs.update(tabId, tmp).then(function(jsTab) {
        return Promise.resolve(fromJs(jsTab));
    });
}
function query(queryInfo) {
    var tmp = {};
    var tmp$1 = Caml_option.undefined_to_opt(queryInfo.active);
    if (tmp$1 !== undefined) {
        tmp.active = Caml_option.valFromOption(tmp$1);
    }
    var tmp$2 = Caml_option.undefined_to_opt(queryInfo.pinned);
    if (tmp$2 !== undefined) {
        tmp.pinned = Caml_option.valFromOption(tmp$2);
    }
    var tmp$3 = Caml_option.undefined_to_opt(queryInfo.audible);
    if (tmp$3 !== undefined) {
        tmp.audible = Caml_option.valFromOption(tmp$3);
    }
    var tmp$4 = Caml_option.undefined_to_opt(queryInfo.muted);
    if (tmp$4 !== undefined) {
        tmp.muted = Caml_option.valFromOption(tmp$4);
    }
    var tmp$5 = Caml_option.undefined_to_opt(queryInfo.highlighted);
    if (tmp$5 !== undefined) {
        tmp.highlighted = Caml_option.valFromOption(tmp$5);
    }
    var tmp$6 = Caml_option.undefined_to_opt(queryInfo.discarded);
    if (tmp$6 !== undefined) {
        tmp.discarded = Caml_option.valFromOption(tmp$6);
    }
    var tmp$7 = Caml_option.undefined_to_opt(queryInfo.autoDiscardable);
    if (tmp$7 !== undefined) {
        tmp.autoDiscardable = Caml_option.valFromOption(tmp$7);
    }
    var tmp$8 = Caml_option.undefined_to_opt(queryInfo.currentWindow);
    if (tmp$8 !== undefined) {
        tmp.currentWindow = Caml_option.valFromOption(tmp$8);
    }
    var tmp$9 = Caml_option.undefined_to_opt(queryInfo.lastFocusedWindow);
    if (tmp$9 !== undefined) {
        tmp.lastFocusedWindow = Caml_option.valFromOption(tmp$9);
    }
    var tmp$10 = OptionUtils$SmartcutsMacros.$neg$question$great(Caml_option.undefined_to_opt(queryInfo.status), Status.tToJs);
    if (tmp$10 !== undefined) {
        tmp.status = Caml_option.valFromOption(tmp$10);
    }
    var tmp$11 = Caml_option.undefined_to_opt(queryInfo.title);
    if (tmp$11 !== undefined) {
        tmp.title = Caml_option.valFromOption(tmp$11);
    }
    var tmp$12 = Caml_option.undefined_to_opt(queryInfo.url);
    if (tmp$12 !== undefined) {
        tmp.url = Caml_option.valFromOption(tmp$12);
    }
    var tmp$13 = Caml_option.undefined_to_opt(queryInfo.windowId);
    if (tmp$13 !== undefined) {
        tmp.windowId = Caml_option.valFromOption(tmp$13);
    }
    var tmp$14 = OptionUtils$SmartcutsMacros.$neg$question$great(Caml_option.undefined_to_opt(queryInfo.windowType), windowTypeToJs);
    if (tmp$14 !== undefined) {
        tmp.windowType = Caml_option.valFromOption(tmp$14);
    }
    var tmp$15 = Caml_option.undefined_to_opt(queryInfo.index);
    if (tmp$15 !== undefined) {
        tmp.index = Caml_option.valFromOption(tmp$15);
    }
    return browser.tabs.query(tmp);
}
function options(format, quality, param) {
    return {
        format: OptionUtils$SmartcutsMacros.$neg$question$great(format, Image$SmartcutsMacros.Format.stringify),
        quality: quality
    };
}
var CaptureVisibleTab = {
    options: options
};
function captureVisibleTab(windowId, formatOpt, quality, param) {
    var format = formatOpt !== undefined ? formatOpt : /* PNG */ 1;
    var options$1 = options(format, quality, undefined);
    return browser.tabs.captureVisibleTab(windowId, options$1).then(function(dataURI) {
        return Promise.resolve({
            format: format,
            data: {
                TAG: /* Base64Encoded */ 0,
                _0: dataURI
            }
        });
    });
}
exports.Tab = Tab;
exports.ReloadProperties = ReloadProperties;
exports.ExecuteScriptContext = ExecuteScriptContext;
exports.SendMessageOptions = SendMessageOptions;
exports.OnActivated = OnActivated;
exports.OnCreated = OnCreated;
exports.OnUpdated = OnUpdated;
exports.OnRemoved = OnRemoved;
exports.OnMoved = OnMoved;
exports.OnDetached = OnDetached;
exports.OnAttached = OnAttached;
exports.OnReplaced = OnReplaced;
exports.OnZoomChange = OnZoomChange;
exports.Create = Create;
exports.create = create;
exports.get = get;
exports.Update = Update;
exports.windowTypeToJs = windowTypeToJs;
exports.windowTypeFromJs = windowTypeFromJs;
exports.QueryInfo = QueryInfo;
exports.updateTab = updateTab;
exports.query = query;
exports.CaptureVisibleTab = CaptureVisibleTab;
exports.captureVisibleTab = captureVisibleTab; /* Status Not a pure module */ 


/***/ }),

/***/ 76584:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Belt_Option = __webpack_require__(46517);
var Caml_option = __webpack_require__(57175);
var Caml_exceptions = __webpack_require__(96181);
var ArrayUtils$SmartcutsMacros = __webpack_require__(6114);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var Browser__Debugger$SmartcutsMacros = __webpack_require__(12913);
var scriptId_encode = Decco.stringToJson;
var scriptId_decode = Decco.stringFromJson;
var unserializableValue_encode = Decco.stringToJson;
var unserializableValue_decode = Decco.stringFromJson;
var remoteObjectId_encode = Decco.stringToJson;
var remoteObjectId_decode = Decco.stringFromJson;
var executionContextId_encode = Decco.intToJson;
var executionContextId_decode = Decco.intFromJson;
var uniqueDebuggerId_encode = Decco.stringToJson;
var uniqueDebuggerId_decode = Decco.stringFromJson;
function t_encode(v1) {
    return Js_dict.fromArray([
        [
            "type_",
            Decco.stringToJson(v1.type)
        ],
        [
            "subtype",
            Decco.optionToJson(Decco.stringToJson, v1.subtype)
        ],
        [
            "value",
            Decco.optionToJson(function(v) {
                return v;
            }, v1.value)
        ],
        [
            "unserializableValue",
            Decco.optionToJson(unserializableValue_encode, v1.unserializableValue)
        ],
        [
            "description",
            Decco.optionToJson(Decco.stringToJson, v1.description)
        ],
        [
            "objectId",
            Decco.optionToJson(remoteObjectId_encode, v1.objectId)
        ]
    ]);
}
function t_decode(v2) {
    var dict = Js_json.classify(v2);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v2);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v2);
    }
    var dict$1 = dict._0;
    var type_ = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type_"), null));
    if (type_.TAG === /* Ok */ 0) {
        var subtype = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "subtype"), null));
        if (subtype.TAG === /* Ok */ 0) {
            var value = Decco.optionFromJson(function(v) {
                return {
                    TAG: /* Ok */ 0,
                    _0: v
                };
            }, Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
            if (value.TAG === /* Ok */ 0) {
                var unserializableValue = Decco.optionFromJson(unserializableValue_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "unserializableValue"), null));
                if (unserializableValue.TAG === /* Ok */ 0) {
                    var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
                    if (description.TAG === /* Ok */ 0) {
                        var objectId = Decco.optionFromJson(remoteObjectId_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "objectId"), null));
                        if (objectId.TAG === /* Ok */ 0) {
                            return {
                                TAG: /* Ok */ 0,
                                _0: {
                                    type: type_._0,
                                    subtype: subtype._0,
                                    value: value._0,
                                    unserializableValue: unserializableValue._0,
                                    description: description._0,
                                    objectId: objectId._0
                                }
                            };
                        }
                        var e = objectId._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".objectId" + e.path,
                                message: e.message,
                                value: e.value
                            }
                        };
                    }
                    var e$1 = description._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".description" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                        }
                    };
                }
                var e$2 = unserializableValue._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".unserializableValue" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            }
            var e$3 = value._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".value" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                }
            };
        }
        var e$4 = subtype._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".subtype" + e$4.path,
                message: e$4.message,
                value: e$4.value
            }
        };
    }
    var e$5 = type_._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".type_" + e$5.path,
            message: e$5.message,
            value: e$5.value
        }
    };
}
var RemoteObject = {
    t_encode: t_encode,
    t_decode: t_decode
};
var PropertyDescriptor = {};
var InternalPropertyDescriptor = {};
var PrivatePropertyDescriptor = {};
function t_encode$1(v) {
    return Js_dict.fromArray([
        [
            "functinoName",
            Decco.stringToJson(v.functinoName)
        ],
        [
            "scriptId",
            Decco.stringToJson(v.scriptId)
        ],
        [
            "url",
            Decco.stringToJson(v.url)
        ],
        [
            "lineNumber",
            Decco.intToJson(v.lineNumber)
        ],
        [
            "columnNumber",
            Decco.intToJson(v.columnNumber)
        ]
    ]);
}
function t_decode$1(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var functinoName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "functinoName"), null));
    if (functinoName.TAG === /* Ok */ 0) {
        var scriptId = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "scriptId"), null));
        if (scriptId.TAG === /* Ok */ 0) {
            var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
            if (url.TAG === /* Ok */ 0) {
                var lineNumber = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "lineNumber"), null));
                if (lineNumber.TAG === /* Ok */ 0) {
                    var columnNumber = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "columnNumber"), null));
                    if (columnNumber.TAG === /* Ok */ 0) {
                        return {
                            TAG: /* Ok */ 0,
                            _0: {
                                functinoName: functinoName._0,
                                scriptId: scriptId._0,
                                url: url._0,
                                lineNumber: lineNumber._0,
                                columnNumber: columnNumber._0
                            }
                        };
                    }
                    var e = columnNumber._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".columnNumber" + e.path,
                            message: e.message,
                            value: e.value
                        }
                    };
                }
                var e$1 = lineNumber._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".lineNumber" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            }
            var e$2 = url._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".url" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                }
            };
        }
        var e$3 = scriptId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".scriptId" + e$3.path,
                message: e$3.message,
                value: e$3.value
            }
        };
    }
    var e$4 = functinoName._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".functinoName" + e$4.path,
            message: e$4.message,
            value: e$4.value
        }
    };
}
var CallFrame = {
    t_encode: t_encode$1,
    t_decode: t_decode$1
};
function t_encode$2(v) {
    return Js_dict.fromArray([
        [
            "id",
            Decco.stringToJson(v.id)
        ],
        [
            "debuggerId",
            Decco.optionToJson(uniqueDebuggerId_encode, v.debuggerId)
        ]
    ]);
}
function t_decode$2(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
    if (id.TAG === /* Ok */ 0) {
        var debuggerId = Decco.optionFromJson(uniqueDebuggerId_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "debuggerId"), null));
        if (debuggerId.TAG === /* Ok */ 0) {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    id: id._0,
                    debuggerId: debuggerId._0
                }
            };
        }
        var e = debuggerId._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".debuggerId" + e.path,
                message: e.message,
                value: e.value
            }
        };
    }
    var e$1 = id._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".id" + e$1.path,
            message: e$1.message,
            value: e$1.value
        }
    };
}
var StackTraceId = {
    t_encode: t_encode$2,
    t_decode: t_decode$2
};
function t_encode$3(v) {
    return Js_dict.fromArray([
        [
            "description",
            Decco.optionToJson(Decco.stringToJson, v.description)
        ],
        [
            "callFrames",
            t_encode$1(v.callFrames)
        ],
        [
            "parent",
            Decco.optionToJson(t_encode$3, v.parent)
        ],
        [
            "parentId",
            Decco.optionToJson(t_encode$2, v.parentId)
        ]
    ]);
}
function t_decode$3(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
    if (description.TAG === /* Ok */ 0) {
        var callFrames = t_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict$1, "callFrames"), null));
        if (callFrames.TAG === /* Ok */ 0) {
            var parent = Decco.optionFromJson(t_decode$3, Belt_Option.getWithDefault(Js_dict.get(dict$1, "parent"), null));
            if (parent.TAG === /* Ok */ 0) {
                var parentId = Decco.optionFromJson(t_decode$2, Belt_Option.getWithDefault(Js_dict.get(dict$1, "parentId"), null));
                if (parentId.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            description: description._0,
                            callFrames: callFrames._0,
                            parent: parent._0,
                            parentId: parentId._0
                        }
                    };
                }
                var e = parentId._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".parentId" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            }
            var e$1 = parent._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".parent" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                }
            };
        }
        var e$2 = callFrames._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".callFrames" + e$2.path,
                message: e$2.message,
                value: e$2.value
            }
        };
    }
    var e$3 = description._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".description" + e$3.path,
            message: e$3.message,
            value: e$3.value
        }
    };
}
var StackTrace = {
    t_encode: t_encode$3,
    t_decode: t_decode$3
};
function t_encode$4(v) {
    return Js_dict.fromArray([
        [
            "exceptionId",
            Decco.intToJson(v.exceptionId)
        ],
        [
            "text",
            Decco.stringToJson(v.text)
        ],
        [
            "lineNumber",
            Decco.intToJson(v.lineNumber)
        ],
        [
            "columnNumber",
            Decco.intToJson(v.columnNumber)
        ],
        [
            "scriptId",
            Decco.optionToJson(scriptId_encode, v.scriptId)
        ],
        [
            "url",
            Decco.optionToJson(Decco.stringToJson, v.url)
        ],
        [
            "stackTrace",
            Decco.optionToJson(t_encode$3, v.stackTrace)
        ],
        [
            "exception_",
            Decco.optionToJson(t_encode, v.exception)
        ],
        [
            "executionContextId",
            Decco.optionToJson(executionContextId_encode, v.executionContextId)
        ]
    ]);
}
function t_decode$4(v) {
    var dict = Js_json.classify(v);
    if (typeof dict === "number") {
        return Decco.error(undefined, "Not an object", v);
    }
    if (dict.TAG !== /* JSONObject */ 2) {
        return Decco.error(undefined, "Not an object", v);
    }
    var dict$1 = dict._0;
    var exceptionId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "exceptionId"), null));
    if (exceptionId.TAG === /* Ok */ 0) {
        var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
        if (text.TAG === /* Ok */ 0) {
            var lineNumber = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "lineNumber"), null));
            if (lineNumber.TAG === /* Ok */ 0) {
                var columnNumber = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "columnNumber"), null));
                if (columnNumber.TAG === /* Ok */ 0) {
                    var scriptId = Decco.optionFromJson(scriptId_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "scriptId"), null));
                    if (scriptId.TAG === /* Ok */ 0) {
                        var url = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
                        if (url.TAG === /* Ok */ 0) {
                            var stackTrace = Decco.optionFromJson(t_decode$3, Belt_Option.getWithDefault(Js_dict.get(dict$1, "stackTrace"), null));
                            if (stackTrace.TAG === /* Ok */ 0) {
                                var exception_ = Decco.optionFromJson(t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "exception_"), null));
                                if (exception_.TAG === /* Ok */ 0) {
                                    var executionContextId = Decco.optionFromJson(executionContextId_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "executionContextId"), null));
                                    if (executionContextId.TAG === /* Ok */ 0) {
                                        return {
                                            TAG: /* Ok */ 0,
                                            _0: {
                                                exceptionId: exceptionId._0,
                                                text: text._0,
                                                lineNumber: lineNumber._0,
                                                columnNumber: columnNumber._0,
                                                scriptId: scriptId._0,
                                                url: url._0,
                                                stackTrace: stackTrace._0,
                                                exception: exception_._0,
                                                executionContextId: executionContextId._0
                                            }
                                        };
                                    }
                                    var e = executionContextId._0;
                                    return {
                                        TAG: /* Error */ 1,
                                        _0: {
                                            path: ".executionContextId" + e.path,
                                            message: e.message,
                                            value: e.value
                                        }
                                    };
                                }
                                var e$1 = exception_._0;
                                return {
                                    TAG: /* Error */ 1,
                                    _0: {
                                        path: ".exception_" + e$1.path,
                                        message: e$1.message,
                                        value: e$1.value
                                    }
                                };
                            }
                            var e$2 = stackTrace._0;
                            return {
                                TAG: /* Error */ 1,
                                _0: {
                                    path: ".stackTrace" + e$2.path,
                                    message: e$2.message,
                                    value: e$2.value
                                }
                            };
                        }
                        var e$3 = url._0;
                        return {
                            TAG: /* Error */ 1,
                            _0: {
                                path: ".url" + e$3.path,
                                message: e$3.message,
                                value: e$3.value
                            }
                        };
                    }
                    var e$4 = scriptId._0;
                    return {
                        TAG: /* Error */ 1,
                        _0: {
                            path: ".scriptId" + e$4.path,
                            message: e$4.message,
                            value: e$4.value
                        }
                    };
                }
                var e$5 = columnNumber._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: ".columnNumber" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            }
            var e$6 = lineNumber._0;
            return {
                TAG: /* Error */ 1,
                _0: {
                    path: ".lineNumber" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                }
            };
        }
        var e$7 = text._0;
        return {
            TAG: /* Error */ 1,
            _0: {
                path: ".text" + e$7.path,
                message: e$7.message,
                value: e$7.value
            }
        };
    }
    var e$8 = exceptionId._0;
    return {
        TAG: /* Error */ 1,
        _0: {
            path: ".exceptionId" + e$8.path,
            message: e$8.message,
            value: e$8.value
        }
    };
}
var ExceptionDetails = {
    t_encode: t_encode$4,
    t_decode: t_decode$4
};
var Exception = /* @__PURE__ */ Caml_exceptions.create("DevProtocol__Runtime-SmartcutsMacros.Exception");
var methodName = "Runtime.getProperties";
var Params = {};
function getPropertyValue(returnValue, propertyName) {
    var arg = returnValue.result;
    var param1 = function param1(propertyDescriptor) {
        if (propertyDescriptor.name === propertyName) {
            return Belt_Option.flatMap(Caml_option.undefined_to_opt(propertyDescriptor.value), function(param) {
                return param.value;
            });
        }
    };
    return ArrayUtils$SmartcutsMacros.shortcut(param1, arg);
}
var Return = {
    getPropertyValue: getPropertyValue
};
var GetProperties = {
    methodName: methodName,
    Params: Params,
    Return: Return
};
function getProperties(objectId, ownProperties, accessorPropertiesOnly, generatePreview, tabId, extensionId, targetId, param) {
    var tmp = {
        objectId: objectId
    };
    if (ownProperties !== undefined) {
        tmp.ownProperties = Caml_option.valFromOption(ownProperties);
    }
    if (accessorPropertiesOnly !== undefined) {
        tmp.accessorPropertiesOnly = Caml_option.valFromOption(accessorPropertiesOnly);
    }
    if (generatePreview !== undefined) {
        tmp.generatePreview = Caml_option.valFromOption(generatePreview);
    }
    var params = tmp;
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName, params);
}
function $$int(x) {
    return {
        value: x
    };
}
var CallArgument = {
    $$int: $$int
};
var methodName$1 = "callFunctionOn";
var Params$1 = {};
var Return$1 = {};
var CallFunctionOn = {
    methodName: methodName$1,
    Params: Params$1,
    Return: Return$1
};
function callFunctionOn(functionDeclaration, objectId, $$arguments, silent, returnByValue, generatePreview, userGesture, awaitPromise, executionContextId, objectGroup, tabId, extensionId, targetId, param) {
    var tmp = {
        functionDeclaration: functionDeclaration
    };
    if (objectId !== undefined) {
        tmp.objectId = Caml_option.valFromOption(objectId);
    }
    if ($$arguments !== undefined) {
        tmp.arguments = Caml_option.valFromOption($$arguments);
    }
    if (silent !== undefined) {
        tmp.silent = Caml_option.valFromOption(silent);
    }
    if (returnByValue !== undefined) {
        tmp.returnByValue = Caml_option.valFromOption(returnByValue);
    }
    if (generatePreview !== undefined) {
        tmp.generatePreview = Caml_option.valFromOption(generatePreview);
    }
    if (userGesture !== undefined) {
        tmp.userGesture = Caml_option.valFromOption(userGesture);
    }
    if (awaitPromise !== undefined) {
        tmp.awaitPromise = Caml_option.valFromOption(awaitPromise);
    }
    if (executionContextId !== undefined) {
        tmp.executionContextId = Caml_option.valFromOption(executionContextId);
    }
    if (objectGroup !== undefined) {
        tmp.objectGroup = Caml_option.valFromOption(objectGroup);
    }
    var params = tmp;
    return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName$1, params).then(function(maybeReturn) {
        return Promise.resolve(OptionUtils$SmartcutsMacros.getExn("Expect Some(return) from callFunctionOn()", maybeReturn));
    });
}
exports.scriptId_encode = scriptId_encode;
exports.scriptId_decode = scriptId_decode;
exports.unserializableValue_encode = unserializableValue_encode;
exports.unserializableValue_decode = unserializableValue_decode;
exports.remoteObjectId_encode = remoteObjectId_encode;
exports.remoteObjectId_decode = remoteObjectId_decode;
exports.executionContextId_encode = executionContextId_encode;
exports.executionContextId_decode = executionContextId_decode;
exports.uniqueDebuggerId_encode = uniqueDebuggerId_encode;
exports.uniqueDebuggerId_decode = uniqueDebuggerId_decode;
exports.RemoteObject = RemoteObject;
exports.PropertyDescriptor = PropertyDescriptor;
exports.InternalPropertyDescriptor = InternalPropertyDescriptor;
exports.PrivatePropertyDescriptor = PrivatePropertyDescriptor;
exports.CallFrame = CallFrame;
exports.StackTraceId = StackTraceId;
exports.StackTrace = StackTrace;
exports.ExceptionDetails = ExceptionDetails;
exports.Exception = Exception;
exports.GetProperties = GetProperties;
exports.getProperties = getProperties;
exports.CallArgument = CallArgument;
exports.CallFunctionOn = CallFunctionOn;
exports.callFunctionOn = callFunctionOn; /* ArrayUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 10413:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Log$SmartcutsMacros = __webpack_require__(78088);
function spy(label, x) {
    console.log(label, x);
    return x;
}
function debug(label, x) {
    Curry._2(Log$SmartcutsMacros.utilSpy.log2, label, x);
    return x;
}
function thenDebug(p) {
    return p.then(function(res) {
        return Promise.resolve(debug("Debug:", res));
    });
}
function getCurrStack(param) {
    return new Error().stack;
}
function consoleWarnStackFor(label) {
    var stack = getCurrStack(undefined);
    console.warn("STACK for " + label, stack);
}
exports.spy = spy;
exports.debug = debug;
exports.thenDebug = thenDebug;
exports.getCurrStack = getCurrStack;
exports.consoleWarnStackFor = consoleWarnStackFor; /* Log-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 22352:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Decco = __webpack_require__(78219);
var Js_json = __webpack_require__(85688);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
function t_encode(exn) {
    if (exn.RE_EXN_ID === "Not_found") {
        return "Not_found";
    } else {
        return "exn";
    }
}
function t_decode(encoded) {
    var str = Js_json.decodeString(encoded);
    if (str !== undefined) {
        if (str === "Not_found") {
            return {
                TAG: /* Ok */ 0,
                _0: {
                    RE_EXN_ID: "Not_found"
                }
            };
        } else {
            return Decco.error(undefined, "Unhandled exception for decco " + StringUtils$SmartcutsMacros.quote(str), encoded);
        }
    } else {
        return Decco.error(undefined, "Couldn't decode json into exn", encoded);
    }
}
var ExnWithDeccoSupport = {
    t_encode: t_encode,
    t_decode: t_decode
};
var extractJsExnFromExn = function(exn) {
    return exn.Error;
};
exports.ExnWithDeccoSupport = ExnWithDeccoSupport;
exports.extractJsExnFromExn = extractJsExnFromExn; /* StringUtils-SmartcutsMacros Not a pure module */ 


/***/ }),

/***/ 79713:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var $$Array = __webpack_require__(53209);
var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_exn = __webpack_require__(82900);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_option = __webpack_require__(57175);
var Caml_js_exceptions = __webpack_require__(74518);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
function maybeAddExnKeyValue(jsExn, key, getMaybeValue, keyValuePairs) {
    var value = Curry._1(getMaybeValue, jsExn);
    if (value !== undefined) {
        return $$Array.append(keyValuePairs, [
            [
                key,
                value
            ]
        ]);
    } else {
        return keyValuePairs;
    }
}
function t_encode(jsExn) {
    return Js_dict.fromArray(maybeAddExnKeyValue(jsExn, "fileName", function(prim) {
        return prim.fileName;
    }, maybeAddExnKeyValue(jsExn, "stack", function(prim) {
        return prim.stack;
    }, maybeAddExnKeyValue(jsExn, "message", function(prim) {
        return prim.message;
    }, maybeAddExnKeyValue(jsExn, "name", function(prim) {
        return prim.name;
    }, [])))));
}
var makeFromNameAndMessageAndStackAndFilename = function makeFromNameAndMessageAndStackAndFilename(name, message, stack, filename) {
    var e = new Error(message);
    e.name = name;
    e.stack = stack;
    e.fileName = filename;
    return e;
};
function t_decode(encoded) {
    var dict = Js_json.decodeObject(encoded);
    if (dict === undefined) {
        return Decco.error(undefined, "Error while decoding", encoded);
    }
    var dict$1 = Caml_option.valFromOption(dict);
    var name = OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.$neg$bang$great(Js_dict.get(dict$1, "name"), Js_json.decodeString));
    var message = OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.$neg$bang$great(Js_dict.get(dict$1, "message"), Js_json.decodeString));
    var stack = OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.$neg$bang$great(Js_dict.get(dict$1, "stack"), Js_json.decodeString));
    var fileName = OptionUtils$SmartcutsMacros.withDefault("undefined", OptionUtils$SmartcutsMacros.$neg$bang$great(Js_dict.get(dict$1, "fileName"), Js_json.decodeString));
    return {
        TAG: /* Ok */ 0,
        _0: makeFromNameAndMessageAndStackAndFilename(name, message, stack, fileName)
    };
}
function errorMessageToJsExn(errorMessage) {
    try {
        return Js_exn.raiseError(errorMessage);
    } catch (raw_error) {
        var error = Caml_js_exceptions.internalToOCamlException(raw_error);
        if (error.RE_EXN_ID === Js_exn.$$Error) {
            return error._1;
        }
        throw error;
    }
}
function stringify(jsExn) {
    var match = jsExn.name;
    var match$1 = jsExn.message;
    if (match !== undefined) {
        if (match$1 !== undefined) {
            return match + (": " + match$1);
        } else {
            return match;
        }
    } else if (match$1 !== undefined) {
        return match$1;
    } else {
        console.error(jsExn);
        return "Error";
    }
}
exports.maybeAddExnKeyValue = maybeAddExnKeyValue;
exports.t_encode = t_encode;
exports.makeFromNameAndMessageAndStackAndFilename = makeFromNameAndMessageAndStackAndFilename;
exports.t_decode = t_decode;
exports.errorMessageToJsExn = errorMessageToJsExn;
exports.stringify = stringify; /* No side effect */ 


/***/ }),

/***/ 72349:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

// Generated by ReScript, PLEASE EDIT WITH CARE

var Curry = __webpack_require__(41386);
var Decco = __webpack_require__(78219);
var Js_exn = __webpack_require__(82900);
var Js_dict = __webpack_require__(97076);
var Js_json = __webpack_require__(85688);
var Caml_obj = __webpack_require__(14923);
var Belt_Array = __webpack_require__(2971);
var Caml_module = __webpack_require__(27236);
var Caml_option = __webpack_require__(57175);
var Caml_exceptions = __webpack_require__(96181);
var Log$SmartcutsMacros = __webpack_require__(78088);
var Util$SmartcutsMacros = __webpack_require__(25092);
var ExnUtils$SmartcutsMacros = __webpack_require__(22352);
var Exceptions$SmartcutsMacros = __webpack_require__(54278);
var GoogleApis$SmartcutsMacros = __webpack_require__(10192);
var JsExnUtils$SmartcutsMacros = __webpack_require__(79713);
var OptionUtils$SmartcutsMacros = __webpack_require__(9324);
var StringUtils$SmartcutsMacros = __webpack_require__(61217);
var DevProtocol__Runtime$SmartcutsMacros = __webpack_require__(76584);
var User_logged_out = /* @__PURE__ */ Caml_exceptions.create("JsPromiseErrorUtils-SmartcutsMacros.User_logged_out");
var ErrorType = Caml_module.init_mod([
    "JsPromiseErrorUtils.re",
    38,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "variantNameWithoutParams"
        ],
        [
            /* Function */ 0,
            "stringify"
        ],
        [
            /* Function */ 0,
            "stringifyWithoutDetails"
        ],
        [
            /* Function */ 0,
            "toJsPromiseError"
        ]
    ]
});
var JsPromiseError = Caml_module.init_mod([
    "JsPromiseErrorUtils.re",
    221,
    4
], {
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "stringify"
        ],
        [
            /* Function */ 0,
            "toJsExn"
        ],
        [
            /* Function */ 0,
            "fromJsExn"
        ],
        [
            /* Function */ 0,
            "isInstanceOfObject"
        ],
        [
            /* Function */ 0,
            "toJsDict"
        ],
        [
            /* Function */ 0,
            "fromJsDict"
        ],
        [
            /* Function */ 0,
            "toHttpResponse"
        ],
        [
            /* Function */ 0,
            "fromHttpResponse"
        ],
        [
            /* Function */ 0,
            "fromExn"
        ],
        [
            /* Function */ 0,
            "toExn"
        ],
        [
            /* Function */ 0,
            "getErrorType"
        ],
        [
            /* Function */ 0,
            "isCouldNotEstablishConnectionReceivingEndDoesNotExistError"
        ],
        [
            /* Function */ 0,
            "isDebuggerIsNotAttachedToTabError"
        ],
        [
            /* Function */ 0,
            "consoleError"
        ],
        [
            /* Function */ 0,
            "consoleError2"
        ],
        [
            /* Function */ 0,
            "consoleError3"
        ]
    ]
});
function t_encode(v1) {
    if (typeof v1 === "number") {
        switch(v1){
            case /* NotFound */ 0:
                return [
                    "NotFound"
                ];
            case /* PromiseCanceled */ 1:
                return [
                    "PromiseCanceled"
                ];
            case /* UserLoggedOut */ 2:
                return [
                    "UserLoggedOut"
                ];
            case /* FaunaGraphqlInternalServerError */ 3:
                return [
                    "FaunaGraphqlInternalServerError"
                ];
            case /* FaunaGraphqlServiceNotAvailable */ 4:
                return [
                    "FaunaGraphqlServiceNotAvailable"
                ];
        }
    } else {
        switch(v1.TAG | 0){
            case /* JsExn */ 0:
                return [
                    "JsExn",
                    JsExnUtils$SmartcutsMacros.t_encode(v1._0)
                ];
            case /* MaxCaptureVisibleTabCallsPerSecondExceeded */ 1:
                return [
                    "MaxCaptureVisibleTabCallsPerSecondExceeded",
                    JsExnUtils$SmartcutsMacros.t_encode(v1._0)
                ];
            case /* GapiIsUndefined */ 2:
                return [
                    "GapiIsUndefined",
                    JsExnUtils$SmartcutsMacros.t_encode(v1._0)
                ];
            case /* InvalidArgument */ 3:
                return [
                    "InvalidArgument",
                    Decco.stringToJson(v1._0)
                ];
            case /* SysError */ 4:
                return [
                    "SysError",
                    Decco.stringToJson(v1._0)
                ];
            case /* InvalidUrl */ 5:
                return [
                    "InvalidUrl",
                    Decco.stringToJson(v1._0)
                ];
            case /* DevProtocolRuntimeException */ 6:
                return [
                    "DevProtocolRuntimeException",
                    DevProtocol__Runtime$SmartcutsMacros.ExceptionDetails.t_encode(v1._0)
                ];
            case /* WaitForPromiseTimedOut */ 7:
                return [
                    "WaitForPromiseTimedOut",
                    Decco.floatToJson(v1._0)
                ];
            case /* WaitForPromisePredicateTimedOut */ 8:
                return [
                    "WaitForPromisePredicateTimedOut",
                    Decco.floatToJson(v1._0)
                ];
            case /* WaitForPredicateError */ 9:
                return [
                    "WaitForPredicateError",
                    t_encode(v1._0)
                ];
            case /* UnauthorizedApiResponse */ 10:
                return [
                    "UnauthorizedApiResponse",
                    Decco.dictToJson(function(v) {
                        return v;
                    }, v1._0)
                ];
            case /* BadApiRequest */ 11:
                return [
                    "BadApiRequest",
                    Decco.dictToJson(function(v) {
                        return v;
                    }, v1._0)
                ];
            case /* HttpResponse */ 12:
                return [
                    "HttpResponse",
                    GoogleApis$SmartcutsMacros.httpResponse_encode(v1._0)
                ];
            case /* UnknownPromiseError */ 13:
                return [
                    "UnknownPromiseError",
                    Curry._1(JsPromiseError.t_encode, v1._0)
                ];
        }
    }
}
function t_decode(v2) {
    var jsonArr = Js_json.classify(v2);
    if (typeof jsonArr === "number") {
        return Decco.error(undefined, "Not a variant", v2);
    }
    if (jsonArr.TAG !== /* JSONArray */ 3) {
        return Decco.error(undefined, "Not a variant", v2);
    }
    var jsonArr$1 = jsonArr._0;
    if (jsonArr$1.length === 0) {
        return Decco.error(undefined, "Expected variant, found empty array", v2);
    }
    var tagged = jsonArr$1.map(Js_json.classify);
    var match = Belt_Array.getExn(tagged, 0);
    if (typeof match !== "number" && match.TAG === /* JSONString */ 0) {
        switch(match._0){
            case "BadApiRequest":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                }
                var v0 = Decco.dictFromJson(function(v) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: v
                    };
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* BadApiRequest */ 11,
                            _0: v0._0
                        }
                    };
                }
                var e = v0._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e.path,
                        message: e.message,
                        value: e.value
                    }
                };
            case "DevProtocolRuntimeException":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                }
                var v0$1 = DevProtocol__Runtime$SmartcutsMacros.ExceptionDetails.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$1.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* DevProtocolRuntimeException */ 6,
                            _0: v0$1._0
                        }
                    };
                }
                var e$1 = v0$1._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                    }
                };
            case "FaunaGraphqlInternalServerError":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* FaunaGraphqlInternalServerError */ 3
                    };
                }
            case "FaunaGraphqlServiceNotAvailable":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* FaunaGraphqlServiceNotAvailable */ 4
                    };
                }
            case "GapiIsUndefined":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                }
                var v0$2 = JsExnUtils$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$2.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* GapiIsUndefined */ 2,
                            _0: v0$2._0
                        }
                    };
                }
                var e$2 = v0$2._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$2.path,
                        message: e$2.message,
                        value: e$2.value
                    }
                };
            case "HttpResponse":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                }
                var v0$3 = GoogleApis$SmartcutsMacros.httpResponse_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$3.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* HttpResponse */ 12,
                            _0: v0$3._0
                        }
                    };
                }
                var e$3 = v0$3._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                    }
                };
            case "InvalidArgument":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                }
                var v0$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$4.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* InvalidArgument */ 3,
                            _0: v0$4._0
                        }
                    };
                }
                var e$4 = v0$4._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                    }
                };
            case "InvalidUrl":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                }
                var v0$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$5.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* InvalidUrl */ 5,
                            _0: v0$5._0
                        }
                    };
                }
                var e$5 = v0$5._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                    }
                };
            case "JsExn":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                }
                var v0$6 = JsExnUtils$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$6.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* JsExn */ 0,
                            _0: v0$6._0
                        }
                    };
                }
                var e$6 = v0$6._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$6.path,
                        message: e$6.message,
                        value: e$6.value
                    }
                };
            case "MaxCaptureVisibleTabCallsPerSecondExceeded":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                }
                var v0$7 = JsExnUtils$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$7.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* MaxCaptureVisibleTabCallsPerSecondExceeded */ 1,
                            _0: v0$7._0
                        }
                    };
                }
                var e$7 = v0$7._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                    }
                };
            case "NotFound":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* NotFound */ 0
                    };
                }
            case "PromiseCanceled":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* PromiseCanceled */ 1
                    };
                }
            case "SysError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                }
                var v0$8 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$8.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* SysError */ 4,
                            _0: v0$8._0
                        }
                    };
                }
                var e$8 = v0$8._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                    }
                };
            case "UnauthorizedApiResponse":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                }
                var v0$9 = Decco.dictFromJson(function(v) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: v
                    };
                }, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$9.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UnauthorizedApiResponse */ 10,
                            _0: v0$9._0
                        }
                    };
                }
                var e$9 = v0$9._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$9.path,
                        message: e$9.message,
                        value: e$9.value
                    }
                };
            case "UnknownPromiseError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                }
                var v0$10 = Curry._1(JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
                if (v0$10.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* UnknownPromiseError */ 13,
                            _0: v0$10._0
                        }
                    };
                }
                var e$10 = v0$10._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$10.path,
                        message: e$10.message,
                        value: e$10.value
                    }
                };
            case "UserLoggedOut":
                if (tagged.length !== 1) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                } else {
                    return {
                        TAG: /* Ok */ 0,
                        _0: /* UserLoggedOut */ 2
                    };
                }
            case "WaitForPredicateError":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                }
                var v0$11 = t_decode(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$11.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* WaitForPredicateError */ 9,
                            _0: v0$11._0
                        }
                    };
                }
                var e$11 = v0$11._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$11.path,
                        message: e$11.message,
                        value: e$11.value
                    }
                };
            case "WaitForPromisePredicateTimedOut":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                }
                var v0$12 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$12.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* WaitForPromisePredicateTimedOut */ 8,
                            _0: v0$12._0
                        }
                    };
                }
                var e$12 = v0$12._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$12.path,
                        message: e$12.message,
                        value: e$12.value
                    }
                };
            case "WaitForPromiseTimedOut":
                if (tagged.length !== 2) {
                    return Decco.error(undefined, "Invalid number of arguments to variant constructor", v2);
                }
                var v0$13 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
                if (v0$13.TAG === /* Ok */ 0) {
                    return {
                        TAG: /* Ok */ 0,
                        _0: {
                            TAG: /* WaitForPromiseTimedOut */ 7,
                            _0: v0$13._0
                        }
                    };
                }
                var e$13 = v0$13._0;
                return {
                    TAG: /* Error */ 1,
                    _0: {
                        path: "[0]" + e$13.path,
                        message: e$13.message,
                        value: e$13.value
                    }
                };
            default:
        }
    }
    return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}
function variantNameWithoutParams(v) {
    if (typeof v === "number") {
        switch(v){
            case /* NotFound */ 0:
                return "NotFound";
            case /* PromiseCanceled */ 1:
                return "PromiseCanceled";
            case /* UserLoggedOut */ 2:
                return "UserLoggedOut";
            case /* FaunaGraphqlInternalServerError */ 3:
                return "FaunaGraphqlInternalServerError";
            case /* FaunaGraphqlServiceNotAvailable */ 4:
                return "FaunaGraphqlServiceNotAvailable";
        }
    } else {
        switch(v.TAG | 0){
            case /* JsExn */ 0:
                return "JsExn";
            case /* MaxCaptureVisibleTabCallsPerSecondExceeded */ 1:
                return "MaxCaptureVisibleTabCallsPerSecondExceeded";
            case /* GapiIsUndefined */ 2:
                return "GapiIsUndefined";
            case /* InvalidArgument */ 3:
                return "InvalidArgument";
            case /* SysError */ 4:
                return "SysError";
            case /* InvalidUrl */ 5:
                return "InvalidUrl";
            case /* DevProtocolRuntimeException */ 6:
                return "DevProtocolRuntimeException";
            case /* WaitForPromiseTimedOut */ 7:
                return "WaitForPromiseTimedOut";
            case /* WaitForPromisePredicateTimedOut */ 8:
                return "WaitForPromisePredicateTimedOut";
            case /* WaitForPredicateError */ 9:
                return "WaitForPredicateError";
            case /* UnauthorizedApiResponse */ 10:
                return "UnauthorizedApiResponse";
            case /* BadApiRequest */ 11:
                return "BadApiRequest";
            case /* HttpResponse */ 12:
                return "HttpResponse";
            case /* UnknownPromiseError */ 13:
                return "UnknownPromiseError";
        }
    }
}
function stringify(v) {
    if (typeof v === "number") {
        switch(v){
            case /* NotFound */ 0:
                return "NotFound";
            case /* PromiseCanceled */ 1:
                return "PromiseCanceled";
            case /* UserLoggedOut */ 2:
                return "UserLoggedOut";
            case /* FaunaGraphqlInternalServerError */ 3:
                return "FaunaGraphqlInternalServerError";
            case /* FaunaGraphqlServiceNotAvailable */ 4:
                return "FaunaGraphqlServiceNotAvailable";
        }
    } else {
        switch(v.TAG | 0){
            case /* JsExn */ 0:
                return "JsExn(" + (JsExnUtils$SmartcutsMacros.stringify(v._0) + ")");
            case /* MaxCaptureVisibleTabCallsPerSecondExceeded */ 1:
                return "MaxCaptureVisibleTabCallsPerSecondExceeded(" + (JsExnUtils$SmartcutsMacros.stringify(v._0) + ")");
            case /* GapiIsUndefined */ 2:
                return "GapiIsUndefined(" + (JsExnUtils$SmartcutsMacros.stringify(v._0) + ")");
            case /* InvalidArgument */ 3:
                return "InvalidArgument(" + (v._0 + ")");
            case /* SysError */ 4:
                return "SysError(" + (v._0 + ")");
            case /* InvalidUrl */ 5:
                return "InvalidUrl(" + (StringUtils$SmartcutsMacros.quote(v._0) + ")");
            case /* DevProtocolRuntimeException */ 6:
                return "DevProtocolRuntimeException(" + (JSON.stringify(DevProtocol__Runtime$SmartcutsMacros.ExceptionDetails.t_encode(v._0)) + ")");
            case /* WaitForPromiseTimedOut */ 7:
                return "WaitForPromiseTimedOut(" + (v._0.toString() + ")");
            case /* WaitForPromisePredicateTimedOut */ 8:
                return "WaitForPromisePredicateTimedOut(" + (v._0.toString() + ")");
            case /* WaitForPredicateError */ 9:
                return "WaitForPredicateError(" + (stringify(v._0) + ")");
            case /* UnauthorizedApiResponse */ 10:
                return "UnauthorizedApiResponse(" + (JSON.stringify(v._0) + ")");
            case /* BadApiRequest */ 11:
                return "BadApiRequest(" + (JSON.stringify(v._0) + ")");
            case /* HttpResponse */ 12:
                return "HttpResponse(httpResponse)";
            case /* UnknownPromiseError */ 13:
                return "UnknownPromiseError(_)";
        }
    }
}
function stringifyWithoutDetails(v) {
    if (typeof v === "number") {
        switch(v){
            case /* NotFound */ 0:
                return "NotFound";
            case /* PromiseCanceled */ 1:
                return "PromiseCanceled";
            case /* UserLoggedOut */ 2:
                return "UserLoggedOut";
            case /* FaunaGraphqlInternalServerError */ 3:
                return "FaunaGraphqlInternalServerError";
            case /* FaunaGraphqlServiceNotAvailable */ 4:
                return "FaunaGraphqlServiceNotAvailable";
        }
    } else {
        switch(v.TAG | 0){
            case /* JsExn */ 0:
                return "JsExn(" + (JsExnUtils$SmartcutsMacros.stringify(v._0) + ")");
            case /* MaxCaptureVisibleTabCallsPerSecondExceeded */ 1:
                return "MaxCaptureVisibleTabCallsPerSecondExceeded";
            case /* GapiIsUndefined */ 2:
                return "GapiIsUndefined";
            case /* InvalidArgument */ 3:
                return "InvalidArgument";
            case /* SysError */ 4:
                return "SysError";
            case /* InvalidUrl */ 5:
                return "InvalidUrl";
            case /* DevProtocolRuntimeException */ 6:
                return "DevProtocolRuntimeException";
            case /* WaitForPromiseTimedOut */ 7:
                return "WaitForPromiseTimedOut";
            case /* WaitForPromisePredicateTimedOut */ 8:
                return "WaitForPromisePredicateTimedOut";
            case /* WaitForPredicateError */ 9:
                return "WaitForPredicateError(" + (stringifyWithoutDetails(v._0) + ")");
            case /* UnauthorizedApiResponse */ 10:
                return "UnauthorizedApiResponse";
            case /* BadApiRequest */ 11:
                return "BadApiRequest";
            case /* HttpResponse */ 12:
                return "HttpResponse";
            case /* UnknownPromiseError */ 13:
                return "UnknownPromiseError";
        }
    }
}
function toJsPromiseError(errorType) {
    if (typeof errorType === "number") {
        switch(errorType){
            case /* NotFound */ 0:
                return Curry._1(JsPromiseError.fromExn, {
                    RE_EXN_ID: "Not_found"
                });
            case /* PromiseCanceled */ 1:
                return Curry._1(JsPromiseError.fromExn, {
                    RE_EXN_ID: Exceptions$SmartcutsMacros.$$Promise.Promise_canceled
                });
            case /* UserLoggedOut */ 2:
                return Curry._1(JsPromiseError.fromExn, {
                    RE_EXN_ID: User_logged_out
                });
            case /* FaunaGraphqlInternalServerError */ 3:
                return Curry._1(JsPromiseError.fromExn, {
                    RE_EXN_ID: Exceptions$SmartcutsMacros.FaunaGraphql.Internal_server_error
                });
            case /* FaunaGraphqlServiceNotAvailable */ 4:
                return Curry._1(JsPromiseError.fromExn, {
                    RE_EXN_ID: Exceptions$SmartcutsMacros.FaunaGraphql.Service_not_available
                });
        }
    } else {
        switch(errorType.TAG | 0){
            case /* InvalidArgument */ 3:
                return Curry._1(JsPromiseError.fromExn, {
                    RE_EXN_ID: "Invalid_argument",
                    _1: errorType._0
                });
            case /* SysError */ 4:
                return Curry._1(JsPromiseError.fromExn, {
                    RE_EXN_ID: "Sys_error",
                    _1: errorType._0
                });
            case /* InvalidUrl */ 5:
                return Curry._1(JsPromiseError.fromExn, {
                    RE_EXN_ID: Exceptions$SmartcutsMacros.$$URL.Invalid_url,
                    _1: errorType._0
                });
            case /* DevProtocolRuntimeException */ 6:
                return Curry._1(JsPromiseError.fromExn, {
                    RE_EXN_ID: DevProtocol__Runtime$SmartcutsMacros.Exception,
                    _1: errorType._0
                });
            case /* WaitForPromiseTimedOut */ 7:
                return Curry._1(JsPromiseError.fromExn, {
                    RE_EXN_ID: Util$SmartcutsMacros.WaitFor.TimedOut,
                    _1: errorType._0
                });
            case /* WaitForPromisePredicateTimedOut */ 8:
                return Curry._1(JsPromiseError.fromExn, {
                    RE_EXN_ID: Util$SmartcutsMacros.WaitFor.PredicateTimedOut,
                    _1: errorType._0
                });
            case /* WaitForPredicateError */ 9:
                return Curry._1(JsPromiseError.fromExn, {
                    RE_EXN_ID: Util$SmartcutsMacros.WaitFor.PredicateError,
                    _1: toJsPromiseError(errorType._0)
                });
            case /* UnauthorizedApiResponse */ 10:
            case /* BadApiRequest */ 11:
                return Curry._1(JsPromiseError.fromJsDict, errorType._0);
            case /* HttpResponse */ 12:
                return Curry._1(JsPromiseError.fromHttpResponse, errorType._0);
            case /* UnknownPromiseError */ 13:
                return errorType._0;
            default:
                return Curry._1(JsPromiseError.fromJsExn, errorType._0);
        }
    }
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "variantNameWithoutParams"
        ],
        [
            /* Function */ 0,
            "stringify"
        ],
        [
            /* Function */ 0,
            "stringifyWithoutDetails"
        ],
        [
            /* Function */ 0,
            "toJsPromiseError"
        ]
    ]
}, ErrorType, {
    t_encode: t_encode,
    t_decode: t_decode,
    variantNameWithoutParams: variantNameWithoutParams,
    stringify: stringify,
    stringifyWithoutDetails: stringifyWithoutDetails,
    toJsPromiseError: toJsPromiseError
});
var isInstanceOfObject = function isInstanceOfObject(v) {
    return typeof v == "object";
};
function getMaybeErrorType_(match) {
    if (!Caml_exceptions.caml_is_extension(match)) {
        return;
    }
    if (match.RE_EXN_ID !== Js_exn.$$Error) {
        if (match.RE_EXN_ID === "Invalid_argument") {
            return {
                TAG: /* InvalidArgument */ 3,
                _0: match._1
            };
        } else if (match.RE_EXN_ID === "Not_found") {
            return /* NotFound */ 0;
        } else if (match.RE_EXN_ID === "Sys_error") {
            return {
                TAG: /* SysError */ 4,
                _0: match._1
            };
        } else if (match.RE_EXN_ID === Exceptions$SmartcutsMacros.$$URL.Invalid_url) {
            return {
                TAG: /* InvalidUrl */ 5,
                _0: match._1
            };
        } else if (match.RE_EXN_ID === DevProtocol__Runtime$SmartcutsMacros.Exception) {
            return {
                TAG: /* DevProtocolRuntimeException */ 6,
                _0: match._1
            };
        } else if (match.RE_EXN_ID === Util$SmartcutsMacros.WaitFor.TimedOut) {
            return {
                TAG: /* WaitForPromiseTimedOut */ 7,
                _0: match._1
            };
        } else if (match.RE_EXN_ID === Util$SmartcutsMacros.WaitFor.PredicateTimedOut) {
            return {
                TAG: /* WaitForPromisePredicateTimedOut */ 8,
                _0: match._1
            };
        } else if (match.RE_EXN_ID === Util$SmartcutsMacros.WaitFor.PredicateError) {
            return {
                TAG: /* WaitForPredicateError */ 9,
                _0: getErrorType(match._1)
            };
        } else if (match.RE_EXN_ID === Exceptions$SmartcutsMacros.$$Promise.Promise_canceled) {
            return /* PromiseCanceled */ 1;
        } else if (match.RE_EXN_ID === User_logged_out) {
            return /* UserLoggedOut */ 2;
        } else if (match.RE_EXN_ID === Exceptions$SmartcutsMacros.FaunaGraphql.Internal_server_error) {
            return /* FaunaGraphqlInternalServerError */ 3;
        } else if (match.RE_EXN_ID === Exceptions$SmartcutsMacros.FaunaGraphql.Service_not_available) {
            return /* FaunaGraphqlServiceNotAvailable */ 4;
        } else {
            return;
        }
    }
    var jsExn = match._1;
    if (Caml_obj.caml_equal(jsExn.message, "This request exceeds the MAX_CAPTURE_VISIBLE_TAB_CALLS_PER_SECOND quota.")) {
        return {
            TAG: /* MaxCaptureVisibleTabCallsPerSecondExceeded */ 1,
            _0: jsExn
        };
    } else if (Caml_obj.caml_equal(jsExn.name, "ReferenceError") && Caml_obj.caml_equal(jsExn.message, "gapi is not defined")) {
        return {
            TAG: /* GapiIsUndefined */ 2,
            _0: jsExn
        };
    } else {
        return {
            TAG: /* JsExn */ 0,
            _0: jsExn
        };
    }
}
function getErrorType(promiseError) {
    var errorType = getMaybeErrorType_(promiseError);
    if (errorType !== undefined) {
        return errorType;
    }
    var match = promiseError.message;
    var match$1 = promiseError.name;
    if (match !== undefined) {
        return {
            TAG: /* JsExn */ 0,
            _0: promiseError
        };
    }
    if (match$1 !== undefined) {
        return {
            TAG: /* JsExn */ 0,
            _0: promiseError
        };
    }
    if (!isInstanceOfObject(promiseError)) {
        return {
            TAG: /* UnknownPromiseError */ 13,
            _0: promiseError
        };
    }
    var json = Js_dict.get(promiseError, "status");
    if (json !== undefined) {
        var num = Js_json.decodeNumber(Caml_option.valFromOption(json));
        if (num === undefined) {
            return {
                TAG: /* UnknownPromiseError */ 13,
                _0: promiseError
            };
        }
        var statusCode = num | 0;
        if (statusCode === 400) {
            return {
                TAG: /* BadApiRequest */ 11,
                _0: promiseError
            };
        } else if (statusCode > 400 && statusCode < 500) {
            return {
                TAG: /* UnauthorizedApiResponse */ 10,
                _0: promiseError
            };
        } else {
            return {
                TAG: /* UnknownPromiseError */ 13,
                _0: promiseError
            };
        }
    }
    var match$2 = Js_dict.get(promiseError, "headers");
    var match$3 = Js_dict.get(promiseError, "body");
    var match$4 = Js_dict.get(promiseError, "result");
    if (match$2 !== undefined && match$3 !== undefined && match$4 !== undefined) {
        return {
            TAG: /* HttpResponse */ 12,
            _0: promiseError
        };
    } else {
        return {
            TAG: /* UnknownPromiseError */ 13,
            _0: promiseError
        };
    }
}
function isCouldNotEstablishConnectionReceivingEndDoesNotExistError(jsPromiseError) {
    var jsExn = Curry._1(JsPromiseError.getErrorType, jsPromiseError);
    if (typeof jsExn === "number" || jsExn.TAG !== /* JsExn */ 0) {
        return false;
    } else {
        return Caml_obj.caml_equal(jsExn._0.message, "Could not establish connection. Receiving end does not exist.");
    }
}
function isDebuggerIsNotAttachedToTabError(jsPromiseError) {
    var jsExn = Curry._1(JsPromiseError.getErrorType, jsPromiseError);
    if (typeof jsExn === "number") {
        return false;
    }
    if (jsExn.TAG !== /* JsExn */ 0) {
        return false;
    }
    var message = jsExn._0.message;
    if (message !== undefined) {
        return /Debugger is not attached to the tab with id: \d+/.test(message);
    } else {
        return false;
    }
}
function t_encode$1(promiseError) {
    var promiseError$1 = getErrorType(promiseError);
    if (typeof promiseError$1 === "number") {
        return Curry._1(ErrorType.t_encode, promiseError$1);
    }
    if (promiseError$1.TAG !== /* UnknownPromiseError */ 13) {
        return Curry._1(ErrorType.t_encode, promiseError$1);
    }
    Curry._2(Log$SmartcutsMacros.decco.error2, "Could not encode promise error", promiseError$1._0);
    return Util$SmartcutsMacros.logAndRaiseJsError("Expected promise error to be a JsExn or Invalid_argument");
}
function t_decode$1(encoded) {
    var decodeError = Curry._1(ErrorType.t_decode, encoded);
    if (decodeError.TAG === /* Ok */ 0) {
        return {
            TAG: /* Ok */ 0,
            _0: Curry._1(ErrorType.toJsPromiseError, decodeError._0)
        };
    } else {
        return {
            TAG: /* Error */ 1,
            _0: decodeError._0
        };
    }
}
function stringify$1(promError) {
    return Curry._1(ErrorType.stringify, getErrorType(promError));
}
function consoleError(error) {
    var errorType = getErrorType(error);
    if (typeof errorType !== "number") {
        switch(errorType.TAG | 0){
            case /* InvalidArgument */ 3:
                var jsExn = ExnUtils$SmartcutsMacros.extractJsExnFromExn(error);
                if (jsExn !== undefined) {
                    var jsExn$1 = Caml_option.valFromOption(jsExn);
                    var _$variantNameWithoutParams = Curry._1(ErrorType.variantNameWithoutParams, errorType);
                    jsExn$1.message = _$variantNameWithoutParams + (": " + errorType._0);
                    console.error(jsExn$1);
                    return;
                }
                console.error(error);
                return;
            case /* JsExn */ 0:
            case /* MaxCaptureVisibleTabCallsPerSecondExceeded */ 1:
            case /* GapiIsUndefined */ 2:
            case /* UnauthorizedApiResponse */ 10:
            case /* BadApiRequest */ 11:
            case /* HttpResponse */ 12:
                console.error(errorType._0);
                return;
            case /* UnknownPromiseError */ 13:
                console.error(error);
                return;
            default:
        }
    }
    var jsExn$2 = ExnUtils$SmartcutsMacros.extractJsExnFromExn(error);
    if (jsExn$2 !== undefined) {
        var jsExn$3 = Caml_option.valFromOption(jsExn$2);
        var variantNameWithoutParams$1 = Curry._1(ErrorType.variantNameWithoutParams, errorType);
        var arg = OptionUtils$SmartcutsMacros.map(jsExn$3.message, function(origMessage) {
            return variantNameWithoutParams$1 + (": " + origMessage);
        });
        jsExn$3.message = function(param) {
            return OptionUtils$SmartcutsMacros.withDefault(param, arg);
        }(variantNameWithoutParams$1);
        console.error(jsExn$3);
        return;
    }
    console.error(error);
}
function consoleError2(msg, error) {
    var httpResponse = getErrorType(error);
    var exit = 0;
    if (typeof httpResponse === "number") {
        exit = 1;
    } else {
        switch(httpResponse.TAG | 0){
            case /* JsExn */ 0:
            case /* MaxCaptureVisibleTabCallsPerSecondExceeded */ 1:
            case /* GapiIsUndefined */ 2:
                exit = 2;
                break;
            case /* UnauthorizedApiResponse */ 10:
            case /* BadApiRequest */ 11:
            case /* HttpResponse */ 12:
                console.error(msg, httpResponse._0);
                return;
            case /* UnknownPromiseError */ 13:
                console.error(msg, error);
                return;
            default:
                exit = 1;
        }
    }
    switch(exit){
        case 1:
            var jsExn = ExnUtils$SmartcutsMacros.extractJsExnFromExn(error);
            if (jsExn !== undefined) {
                var jsExn$1 = Caml_option.valFromOption(jsExn);
                var _$variantNameWithoutParams = Curry._1(ErrorType.variantNameWithoutParams, httpResponse);
                var arg = OptionUtils$SmartcutsMacros.map(jsExn$1.message, function(origMessage) {
                    return _$variantNameWithoutParams + (": " + origMessage);
                });
                jsExn$1.message = function(param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                }(_$variantNameWithoutParams);
                console.error(msg, jsExn$1);
                return;
            }
            console.error(error);
            return;
        case 2:
            console.error(msg, httpResponse._0);
            return;
    }
}
function consoleError3(msg, error, extra) {
    var errorType = getErrorType(error);
    var exit = 0;
    if (typeof errorType === "number") {
        exit = 1;
    } else {
        switch(errorType.TAG | 0){
            case /* JsExn */ 0:
            case /* MaxCaptureVisibleTabCallsPerSecondExceeded */ 1:
            case /* GapiIsUndefined */ 2:
                exit = 2;
                break;
            case /* InvalidArgument */ 3:
                var innerMessage = errorType._0;
                var jsExn = ExnUtils$SmartcutsMacros.extractJsExnFromExn(error);
                if (jsExn !== undefined) {
                    var jsExn$1 = Caml_option.valFromOption(jsExn);
                    var _$variantNameWithoutParams = Curry._1(ErrorType.variantNameWithoutParams, errorType);
                    var arg = OptionUtils$SmartcutsMacros.map(jsExn$1.message, function(origMessage) {
                        return _$variantNameWithoutParams + ("(" + (innerMessage + ("): " + origMessage)));
                    });
                    jsExn$1.message = function(param) {
                        return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                    }(_$variantNameWithoutParams);
                    console.error(msg, jsExn$1, extra);
                    return;
                }
                console.error(error);
                return;
            case /* UnauthorizedApiResponse */ 10:
            case /* BadApiRequest */ 11:
            case /* HttpResponse */ 12:
                console.error(msg, errorType._0, extra);
                return;
            case /* UnknownPromiseError */ 13:
                console.error(msg, error, extra);
                return;
            default:
                exit = 1;
        }
    }
    switch(exit){
        case 1:
            var jsExn$2 = ExnUtils$SmartcutsMacros.extractJsExnFromExn(error);
            if (jsExn$2 !== undefined) {
                var jsExn$3 = Caml_option.valFromOption(jsExn$2);
                var variantNameWithoutParams$1 = Curry._1(ErrorType.variantNameWithoutParams, errorType);
                var arg$1 = OptionUtils$SmartcutsMacros.map(jsExn$3.message, function(origMessage) {
                    return variantNameWithoutParams$1 + (": " + origMessage);
                });
                jsExn$3.message = function(param) {
                    return OptionUtils$SmartcutsMacros.withDefault(param, arg$1);
                }(variantNameWithoutParams$1);
                console.error(msg, jsExn$3, extra);
                return;
            }
            console.error(error);
            return;
        case 2:
            console.error(msg, errorType._0, extra);
            return;
    }
}
Caml_module.update_mod({
    TAG: /* Module */ 0,
    _0: [
        [
            /* Function */ 0,
            "t_encode"
        ],
        [
            /* Function */ 0,
            "t_decode"
        ],
        [
            /* Function */ 0,
            "stringify"
        ],
        [
            /* Function */ 0,
            "toJsExn"
        ],
        [
            /* Function */ 0,
            "fromJsExn"
        ],
        [
            /* Function */ 0,
            "isInstanceOfObject"
        ],
        [
            /* Function */ 0,
            "toJsDict"
        ],
        [
            /* Function */ 0,
            "fromJsDict"
        ],
        [
            /* Function */ 0,
            "toHttpResponse"
        ],
        [
            /* Function */ 0,
            "fromHttpResponse"
        ],
        [
            /* Function */ 0,
            "fromExn"
        ],
        [
            /* Function */ 0,
            "toExn"
        ],
        [
            /* Function */ 0,
            "getErrorType"
        ],
        [
            /* Function */ 0,
            "isCouldNotEstablishConnectionReceivingEndDoesNotExistError"
        ],
        [
            /* Function */ 0,
            "isDebuggerIsNotAttachedToTabError"
        ],
        [
            /* Function */ 0,
            "consoleError"
        ],
        [
            /* Function */ 0,
            "consoleError2"
        ],
        [
            /* Function */ 0,
            "consoleError3"
        ]
    ]
}, JsPromiseError, {
    t_encode: t_encode$1,
    t_decode: t_decode$1,
    stringify: stringify$1,
    toJsExn: function(prim) {
        return prim;
    },
    fromJsExn: function(prim) {
        return prim;
    },
    isInstanceOfObject: isInstanceOfObject,
    toJsDict: function(prim) {
        return prim;
    },
    fromJsDict: function(prim) {
        return prim;
    },
    toHttpResponse: function(prim) {
        return prim;
    },
    fromHttpResponse: function(prim) {
        return prim;
    },
    fromExn: function(prim) {
        return prim;
    },
    toExn: function(prim) {
        return prim;
    },
    getErrorType: getErrorType,
    isCouldNotEstablishConnectionReceivingEndDoesNotExistError: isCouldNotEstablishConnectionReceivingEndDoesNotExistError,
    isDebuggerIsNotAttachedToTabError: isDebuggerIsNotAttachedToTabError,
    consoleError: consoleError,
    consoleError2: consoleError2,
    consoleError3: consoleError3
});
exports.User_logged_out = User_logged_out;
exports.ErrorType = ErrorType;
exports.JsPromiseError = JsPromiseError; /* ErrorType Not a pure module */ 


/***/ })

}]);